/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as AuthenticatedIndexRouteImport } from './routes/_authenticated/index'
import { Route as PublicLogoutRouteImport } from './routes/_public/logout'
import { Route as PublicLoginRouteImport } from './routes/_public/login'
import { Route as AuthenticatedAliasRouteImport } from './routes/_authenticated/$alias'
import { Route as PublicSignupIndexRouteImport } from './routes/_public/signup/index'
import { Route as PublicRegisterIndexRouteImport } from './routes/_public/register/index'
import { Route as PublicSignupOrganizationRouteImport } from './routes/_public/signup/organization'
import { Route as PublicSignupCodeRouteImport } from './routes/_public/signup/code'
import { Route as PublicAuthCodeRouteImport } from './routes/_public/auth/code'
import { Route as PublicAuthCallbackRouteImport } from './routes/_public/auth/callback'
import { Route as AuthenticatedWelcomeOrganizationDetailsRouteImport } from './routes/_authenticated/welcome/organization-details'
import { Route as AuthenticatedOauthAuthorizeRouteImport } from './routes/_authenticated/oauth/authorize'
import { Route as AuthenticatedAliasV2RouteImport } from './routes/_authenticated/$alias/v2'
import { Route as AuthenticatedAliasSettingsRouteImport } from './routes/_authenticated/$alias/settings'
import { Route as AuthenticatedAliasAppRouteImport } from './routes/_authenticated/$alias/_app'
import { Route as AuthenticatedAliasSettingsIndexRouteImport } from './routes/_authenticated/$alias/settings/index'
import { Route as AuthenticatedAliasAppIndexRouteImport } from './routes/_authenticated/$alias/_app/index'
import { Route as AuthenticatedOrgOrgIdSplatRouteImport } from './routes/_authenticated/org_.$orgId.$'
import { Route as AuthenticatedAliasV2GenerateRouteImport } from './routes/_authenticated/$alias/v2/generate'
import { Route as AuthenticatedAliasSetupUploadRouteImport } from './routes/_authenticated/$alias/setup/upload'
import { Route as AuthenticatedAliasSetupCustomizeRouteImport } from './routes/_authenticated/$alias/setup/customize'
import { Route as AuthenticatedAliasSettingsGoalsRouteImport } from './routes/_authenticated/$alias/settings/goals'
import { Route as AuthenticatedAliasAppReportsRouteImport } from './routes/_authenticated/$alias/_app/reports'
import { Route as AuthenticatedAliasAppHighlightsRouteImport } from './routes/_authenticated/$alias/_app/highlights'
import { Route as AuthenticatedAliasSettingsWorkspacesIndexRouteImport } from './routes/_authenticated/$alias/settings/workspaces/index'
import { Route as AuthenticatedAliasSettingsTranscriptionIndexRouteImport } from './routes/_authenticated/$alias/settings/transcription/index'
import { Route as AuthenticatedAliasSettingsTopicsIndexRouteImport } from './routes/_authenticated/$alias/settings/topics/index'
import { Route as AuthenticatedAliasSettingsScorecardsIndexRouteImport } from './routes/_authenticated/$alias/settings/scorecards/index'
import { Route as AuthenticatedAliasSettingsRolesIndexRouteImport } from './routes/_authenticated/$alias/settings/roles/index'
import { Route as AuthenticatedAliasSettingsProfileIndexRouteImport } from './routes/_authenticated/$alias/settings/profile/index'
import { Route as AuthenticatedAliasSettingsOrganizationIndexRouteImport } from './routes/_authenticated/$alias/settings/organization/index'
import { Route as AuthenticatedAliasSettingsMetricsIndexRouteImport } from './routes/_authenticated/$alias/settings/metrics/index'
import { Route as AuthenticatedAliasSettingsMembersIndexRouteImport } from './routes/_authenticated/$alias/settings/members/index'
import { Route as AuthenticatedAliasSettingsIntentsIndexRouteImport } from './routes/_authenticated/$alias/settings/intents/index'
import { Route as AuthenticatedAliasSettingsGroupsIndexRouteImport } from './routes/_authenticated/$alias/settings/groups/index'
import { Route as AuthenticatedAliasSettingsFlagsIndexRouteImport } from './routes/_authenticated/$alias/settings/flags/index'
import { Route as AuthenticatedAliasSettingsChannelsIndexRouteImport } from './routes/_authenticated/$alias/settings/channels/index'
import { Route as AuthenticatedAliasSettingsBillingIndexRouteImport } from './routes/_authenticated/$alias/settings/billing/index'
import { Route as AuthenticatedAliasSettingsAutoQaPreferencesIndexRouteImport } from './routes/_authenticated/$alias/settings/auto-qa-preferences/index'
import { Route as AuthenticatedAliasSettingsApiTokensIndexRouteImport } from './routes/_authenticated/$alias/settings/api-tokens/index'
import { Route as AuthenticatedAliasSettingsAlertsIndexRouteImport } from './routes/_authenticated/$alias/settings/alerts/index'
import { Route as AuthenticatedAliasAppSearchIndexRouteImport } from './routes/_authenticated/$alias/_app/search/index'
import { Route as AuthenticatedAliasAppScorecardsIndexRouteImport } from './routes/_authenticated/$alias/_app/scorecards/index'
import { Route as AuthenticatedAliasAppMembersIndexRouteImport } from './routes/_authenticated/$alias/_app/members/index'
import { Route as AuthenticatedAliasAppLeaderboardIndexRouteImport } from './routes/_authenticated/$alias/_app/leaderboard/index'
import { Route as AuthenticatedAliasAppIndicatorsIndexRouteImport } from './routes/_authenticated/$alias/_app/indicators/index'
import { Route as AuthenticatedAliasAppHighlightsIndexRouteImport } from './routes/_authenticated/$alias/_app/highlights/index'
import { Route as AuthenticatedAliasAppExploreIndexRouteImport } from './routes/_authenticated/$alias/_app/explore/index'
import { Route as AuthenticatedORGSplatRouteImport } from './routes/_authenticated/o.r.g.$'
import { Route as AuthenticatedAliasV2ScorecardScorecardIdRouteImport } from './routes/_authenticated/$alias/v2/scorecard/$scorecardId'
import { Route as AuthenticatedAliasSettingsWorkspacesWorkspaceIdRouteImport } from './routes/_authenticated/$alias/settings/workspaces/$workspaceId'
import { Route as AuthenticatedAliasSettingsScorecardsScorecardIdRouteImport } from './routes/_authenticated/$alias/settings/scorecards/$scorecardId'
import { Route as AuthenticatedAliasSettingsRolesRoleIdRouteImport } from './routes/_authenticated/$alias/settings/roles/$roleId'
import { Route as AuthenticatedAliasSettingsMembersInvitesRouteImport } from './routes/_authenticated/$alias/settings/members/invites'
import { Route as AuthenticatedAliasSettingsMembersMemberIdRouteImport } from './routes/_authenticated/$alias/settings/members/$memberId'
import { Route as AuthenticatedAliasSettingsGroupsGroupIdRouteImport } from './routes/_authenticated/$alias/settings/groups/$groupId'
import { Route as AuthenticatedAliasSettingsChannelsChannelIdRouteImport } from './routes/_authenticated/$alias/settings/channels/$channelId'
import { Route as AuthenticatedAliasSettingsApiTokensNewRouteImport } from './routes/_authenticated/$alias/settings/api-tokens/new'
import { Route as AuthenticatedAliasSettingsAlertsAlertIdRouteImport } from './routes/_authenticated/$alias/settings/alerts/$alertId'
import { Route as AuthenticatedAliasPrintEvaluationsEvaluationIdRouteImport } from './routes/_authenticated/$alias/print/evaluations.$evaluationId'
import { Route as AuthenticatedAliasIntegrationsIntegrationIdCreateContactRouteImport } from './routes/_authenticated/$alias/integrations/$integrationId/create-contact'
import { Route as AuthenticatedAliasIntegrationsIntegrationIdCallbackRouteImport } from './routes/_authenticated/$alias/integrations/$integrationId/callback'
import { Route as AuthenticatedAliasIntegrationsIntegrationIdActivateRouteImport } from './routes/_authenticated/$alias/integrations/$integrationId/activate'
import { Route as AuthenticatedAliasAppScorecardScorecardIdRouteImport } from './routes/_authenticated/$alias/_app/scorecard/$scorecardId'
import { Route as AuthenticatedAliasAppMembersMemberIdRouteImport } from './routes/_authenticated/$alias/_app/members/$memberId'
import { Route as AuthenticatedAliasAppInteractionLookupRouteImport } from './routes/_authenticated/$alias/_app/interaction/lookup'
import { Route as AuthenticatedAliasAppContactLogsContactLogIdRouteImport } from './routes/_authenticated/$alias/_app/contact-logs/$contactLogId'
import { Route as AuthenticatedAliasV2ScorecardScorecardIdIndexRouteImport } from './routes/_authenticated/$alias/v2/scorecard/$scorecardId.index'
import { Route as AuthenticatedAliasSettingsScorecardsScorecardIdIndexRouteImport } from './routes/_authenticated/$alias/settings/scorecards/$scorecardId/index'
import { Route as AuthenticatedAliasAppScorecardNewIndexRouteImport } from './routes/_authenticated/$alias/_app/scorecard/new/index'
import { Route as AuthenticatedAliasAppScorecardScorecardIdIndexRouteImport } from './routes/_authenticated/$alias/_app/scorecard/$scorecardId/index'
import { Route as AuthenticatedAliasAppReportsPivotIndexRouteImport } from './routes/_authenticated/$alias/_app/reports/pivot/index'
import { Route as AuthenticatedAliasAppInteractionContactLogIdIndexRouteImport } from './routes/_authenticated/$alias/_app/interaction/$contactLogId/index'
import { Route as AuthenticatedAliasAppIndicatorsIndicatorIdIndexRouteImport } from './routes/_authenticated/$alias/_app/indicators/$indicatorId/index'
import { Route as AuthenticatedAliasAppScorecardNewTemplateRouteImport } from './routes/_authenticated/$alias/_app/scorecard/new/template'
import { Route as AuthenticatedAliasAppScorecardScorecardIdEditRouteImport } from './routes/_authenticated/$alias/_app/scorecard/$scorecardId/edit'
import { Route as AuthenticatedAliasAppHighlightsHighlightCategoryIdNewRouteImport } from './routes/_authenticated/$alias/_app/highlights/$highlightCategoryId.new'
import { Route as AuthenticatedAliasSettingsScorecardsScorecardIdSettingsIndexRouteImport } from './routes/_authenticated/$alias/settings/scorecards/$scorecardId/settings/index'
import { Route as AuthenticatedAliasSettingsScorecardsScorecardIdCriteriaIndexRouteImport } from './routes/_authenticated/$alias/settings/scorecards/$scorecardId/criteria/index'
import { Route as AuthenticatedAliasV2ScorecardScorecardIdCriteriaCriteriaIdRouteImport } from './routes/_authenticated/$alias/v2/scorecard/$scorecardId.criteria.$criteriaId'
import { Route as AuthenticatedAliasSettingsScorecardsScorecardIdCriteriaItemIdRouteImport } from './routes/_authenticated/$alias/settings/scorecards/$scorecardId/criteria/$itemId'
import { Route as AuthenticatedAliasAppScorecardScorecardIdEditIndex2RouteImport } from './routes/_authenticated/$alias/_app/scorecard/$scorecardId/edit.index2'
import { Route as AuthenticatedAliasAppScorecardScorecardIdEditCriteriaIdRouteImport } from './routes/_authenticated/$alias/_app/scorecard/$scorecardId/edit.$criteriaId'
import { Route as AuthenticatedAliasAppInteractionContactLogIdDisputeEvaluationIdRouteImport } from './routes/_authenticated/$alias/_app/interaction/$contactLogId/dispute/$evaluationId'
import { Route as AuthenticatedAliasAppHighlightsHighlightCategoryIdEditHighlightIdRouteImport } from './routes/_authenticated/$alias/_app/highlights/$highlightCategoryId.edit.$highlightId'
import { Route as AuthenticatedAliasSettingsScorecardsScorecardIdCriteriaNewSectionIdRouteImport } from './routes/_authenticated/$alias/settings/scorecards/$scorecardId/criteria/new/$sectionId'

const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedIndexRoute = AuthenticatedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const PublicLogoutRoute = PublicLogoutRouteImport.update({
  id: '/_public/logout',
  path: '/logout',
  getParentRoute: () => rootRouteImport,
} as any)
const PublicLoginRoute = PublicLoginRouteImport.update({
  id: '/_public/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedAliasRoute = AuthenticatedAliasRouteImport.update({
  id: '/$alias',
  path: '/$alias',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const PublicSignupIndexRoute = PublicSignupIndexRouteImport.update({
  id: '/_public/signup/',
  path: '/signup/',
  getParentRoute: () => rootRouteImport,
} as any)
const PublicRegisterIndexRoute = PublicRegisterIndexRouteImport.update({
  id: '/_public/register/',
  path: '/register/',
  getParentRoute: () => rootRouteImport,
} as any)
const PublicSignupOrganizationRoute =
  PublicSignupOrganizationRouteImport.update({
    id: '/_public/signup/organization',
    path: '/signup/organization',
    getParentRoute: () => rootRouteImport,
  } as any)
const PublicSignupCodeRoute = PublicSignupCodeRouteImport.update({
  id: '/_public/signup/code',
  path: '/signup/code',
  getParentRoute: () => rootRouteImport,
} as any)
const PublicAuthCodeRoute = PublicAuthCodeRouteImport.update({
  id: '/_public/auth/code',
  path: '/auth/code',
  getParentRoute: () => rootRouteImport,
} as any)
const PublicAuthCallbackRoute = PublicAuthCallbackRouteImport.update({
  id: '/_public/auth/callback',
  path: '/auth/callback',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedWelcomeOrganizationDetailsRoute =
  AuthenticatedWelcomeOrganizationDetailsRouteImport.update({
    id: '/welcome/organization-details',
    path: '/welcome/organization-details',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedOauthAuthorizeRoute =
  AuthenticatedOauthAuthorizeRouteImport.update({
    id: '/oauth/authorize',
    path: '/oauth/authorize',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAliasV2Route = AuthenticatedAliasV2RouteImport.update({
  id: '/v2',
  path: '/v2',
  getParentRoute: () => AuthenticatedAliasRoute,
} as any)
const AuthenticatedAliasSettingsRoute =
  AuthenticatedAliasSettingsRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => AuthenticatedAliasRoute,
  } as any)
const AuthenticatedAliasAppRoute = AuthenticatedAliasAppRouteImport.update({
  id: '/_app',
  getParentRoute: () => AuthenticatedAliasRoute,
} as any)
const AuthenticatedAliasSettingsIndexRoute =
  AuthenticatedAliasSettingsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedAliasSettingsRoute,
  } as any)
const AuthenticatedAliasAppIndexRoute =
  AuthenticatedAliasAppIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedAliasAppRoute,
  } as any)
const AuthenticatedOrgOrgIdSplatRoute =
  AuthenticatedOrgOrgIdSplatRouteImport.update({
    id: '/org_/$orgId/$',
    path: '/org/$orgId/$',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAliasV2GenerateRoute =
  AuthenticatedAliasV2GenerateRouteImport.update({
    id: '/generate',
    path: '/generate',
    getParentRoute: () => AuthenticatedAliasV2Route,
  } as any)
const AuthenticatedAliasSetupUploadRoute =
  AuthenticatedAliasSetupUploadRouteImport.update({
    id: '/setup/upload',
    path: '/setup/upload',
    getParentRoute: () => AuthenticatedAliasRoute,
  } as any)
const AuthenticatedAliasSetupCustomizeRoute =
  AuthenticatedAliasSetupCustomizeRouteImport.update({
    id: '/setup/customize',
    path: '/setup/customize',
    getParentRoute: () => AuthenticatedAliasRoute,
  } as any)
const AuthenticatedAliasSettingsGoalsRoute =
  AuthenticatedAliasSettingsGoalsRouteImport.update({
    id: '/goals',
    path: '/goals',
    getParentRoute: () => AuthenticatedAliasSettingsRoute,
  } as any)
const AuthenticatedAliasAppReportsRoute =
  AuthenticatedAliasAppReportsRouteImport.update({
    id: '/reports',
    path: '/reports',
    getParentRoute: () => AuthenticatedAliasAppRoute,
  } as any)
const AuthenticatedAliasAppHighlightsRoute =
  AuthenticatedAliasAppHighlightsRouteImport.update({
    id: '/highlights',
    path: '/highlights',
    getParentRoute: () => AuthenticatedAliasAppRoute,
  } as any)
const AuthenticatedAliasSettingsWorkspacesIndexRoute =
  AuthenticatedAliasSettingsWorkspacesIndexRouteImport.update({
    id: '/workspaces/',
    path: '/workspaces/',
    getParentRoute: () => AuthenticatedAliasSettingsRoute,
  } as any)
const AuthenticatedAliasSettingsTranscriptionIndexRoute =
  AuthenticatedAliasSettingsTranscriptionIndexRouteImport.update({
    id: '/transcription/',
    path: '/transcription/',
    getParentRoute: () => AuthenticatedAliasSettingsRoute,
  } as any)
const AuthenticatedAliasSettingsTopicsIndexRoute =
  AuthenticatedAliasSettingsTopicsIndexRouteImport.update({
    id: '/topics/',
    path: '/topics/',
    getParentRoute: () => AuthenticatedAliasSettingsRoute,
  } as any)
const AuthenticatedAliasSettingsScorecardsIndexRoute =
  AuthenticatedAliasSettingsScorecardsIndexRouteImport.update({
    id: '/scorecards/',
    path: '/scorecards/',
    getParentRoute: () => AuthenticatedAliasSettingsRoute,
  } as any)
const AuthenticatedAliasSettingsRolesIndexRoute =
  AuthenticatedAliasSettingsRolesIndexRouteImport.update({
    id: '/roles/',
    path: '/roles/',
    getParentRoute: () => AuthenticatedAliasSettingsRoute,
  } as any)
const AuthenticatedAliasSettingsProfileIndexRoute =
  AuthenticatedAliasSettingsProfileIndexRouteImport.update({
    id: '/profile/',
    path: '/profile/',
    getParentRoute: () => AuthenticatedAliasSettingsRoute,
  } as any)
const AuthenticatedAliasSettingsOrganizationIndexRoute =
  AuthenticatedAliasSettingsOrganizationIndexRouteImport.update({
    id: '/organization/',
    path: '/organization/',
    getParentRoute: () => AuthenticatedAliasSettingsRoute,
  } as any)
const AuthenticatedAliasSettingsMetricsIndexRoute =
  AuthenticatedAliasSettingsMetricsIndexRouteImport.update({
    id: '/metrics/',
    path: '/metrics/',
    getParentRoute: () => AuthenticatedAliasSettingsRoute,
  } as any)
const AuthenticatedAliasSettingsMembersIndexRoute =
  AuthenticatedAliasSettingsMembersIndexRouteImport.update({
    id: '/members/',
    path: '/members/',
    getParentRoute: () => AuthenticatedAliasSettingsRoute,
  } as any)
const AuthenticatedAliasSettingsIntentsIndexRoute =
  AuthenticatedAliasSettingsIntentsIndexRouteImport.update({
    id: '/intents/',
    path: '/intents/',
    getParentRoute: () => AuthenticatedAliasSettingsRoute,
  } as any)
const AuthenticatedAliasSettingsGroupsIndexRoute =
  AuthenticatedAliasSettingsGroupsIndexRouteImport.update({
    id: '/groups/',
    path: '/groups/',
    getParentRoute: () => AuthenticatedAliasSettingsRoute,
  } as any)
const AuthenticatedAliasSettingsFlagsIndexRoute =
  AuthenticatedAliasSettingsFlagsIndexRouteImport.update({
    id: '/flags/',
    path: '/flags/',
    getParentRoute: () => AuthenticatedAliasSettingsRoute,
  } as any)
const AuthenticatedAliasSettingsChannelsIndexRoute =
  AuthenticatedAliasSettingsChannelsIndexRouteImport.update({
    id: '/channels/',
    path: '/channels/',
    getParentRoute: () => AuthenticatedAliasSettingsRoute,
  } as any)
const AuthenticatedAliasSettingsBillingIndexRoute =
  AuthenticatedAliasSettingsBillingIndexRouteImport.update({
    id: '/billing/',
    path: '/billing/',
    getParentRoute: () => AuthenticatedAliasSettingsRoute,
  } as any)
const AuthenticatedAliasSettingsAutoQaPreferencesIndexRoute =
  AuthenticatedAliasSettingsAutoQaPreferencesIndexRouteImport.update({
    id: '/auto-qa-preferences/',
    path: '/auto-qa-preferences/',
    getParentRoute: () => AuthenticatedAliasSettingsRoute,
  } as any)
const AuthenticatedAliasSettingsApiTokensIndexRoute =
  AuthenticatedAliasSettingsApiTokensIndexRouteImport.update({
    id: '/api-tokens/',
    path: '/api-tokens/',
    getParentRoute: () => AuthenticatedAliasSettingsRoute,
  } as any)
const AuthenticatedAliasSettingsAlertsIndexRoute =
  AuthenticatedAliasSettingsAlertsIndexRouteImport.update({
    id: '/alerts/',
    path: '/alerts/',
    getParentRoute: () => AuthenticatedAliasSettingsRoute,
  } as any)
const AuthenticatedAliasAppSearchIndexRoute =
  AuthenticatedAliasAppSearchIndexRouteImport.update({
    id: '/search/',
    path: '/search/',
    getParentRoute: () => AuthenticatedAliasAppRoute,
  } as any)
const AuthenticatedAliasAppScorecardsIndexRoute =
  AuthenticatedAliasAppScorecardsIndexRouteImport.update({
    id: '/scorecards/',
    path: '/scorecards/',
    getParentRoute: () => AuthenticatedAliasAppRoute,
  } as any)
const AuthenticatedAliasAppMembersIndexRoute =
  AuthenticatedAliasAppMembersIndexRouteImport.update({
    id: '/members/',
    path: '/members/',
    getParentRoute: () => AuthenticatedAliasAppRoute,
  } as any)
const AuthenticatedAliasAppLeaderboardIndexRoute =
  AuthenticatedAliasAppLeaderboardIndexRouteImport.update({
    id: '/leaderboard/',
    path: '/leaderboard/',
    getParentRoute: () => AuthenticatedAliasAppRoute,
  } as any)
const AuthenticatedAliasAppIndicatorsIndexRoute =
  AuthenticatedAliasAppIndicatorsIndexRouteImport.update({
    id: '/indicators/',
    path: '/indicators/',
    getParentRoute: () => AuthenticatedAliasAppRoute,
  } as any)
const AuthenticatedAliasAppHighlightsIndexRoute =
  AuthenticatedAliasAppHighlightsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedAliasAppHighlightsRoute,
  } as any)
const AuthenticatedAliasAppExploreIndexRoute =
  AuthenticatedAliasAppExploreIndexRouteImport.update({
    id: '/explore/',
    path: '/explore/',
    getParentRoute: () => AuthenticatedAliasAppRoute,
  } as any)
const AuthenticatedORGSplatRoute = AuthenticatedORGSplatRouteImport.update({
  id: '/o/r/g/$',
  path: '/o/r/g/$',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedAliasV2ScorecardScorecardIdRoute =
  AuthenticatedAliasV2ScorecardScorecardIdRouteImport.update({
    id: '/scorecard/$scorecardId',
    path: '/scorecard/$scorecardId',
    getParentRoute: () => AuthenticatedAliasV2Route,
  } as any)
const AuthenticatedAliasSettingsWorkspacesWorkspaceIdRoute =
  AuthenticatedAliasSettingsWorkspacesWorkspaceIdRouteImport.update({
    id: '/workspaces/$workspaceId',
    path: '/workspaces/$workspaceId',
    getParentRoute: () => AuthenticatedAliasSettingsRoute,
  } as any)
const AuthenticatedAliasSettingsScorecardsScorecardIdRoute =
  AuthenticatedAliasSettingsScorecardsScorecardIdRouteImport.update({
    id: '/scorecards/$scorecardId',
    path: '/scorecards/$scorecardId',
    getParentRoute: () => AuthenticatedAliasSettingsRoute,
  } as any)
const AuthenticatedAliasSettingsRolesRoleIdRoute =
  AuthenticatedAliasSettingsRolesRoleIdRouteImport.update({
    id: '/roles/$roleId',
    path: '/roles/$roleId',
    getParentRoute: () => AuthenticatedAliasSettingsRoute,
  } as any)
const AuthenticatedAliasSettingsMembersInvitesRoute =
  AuthenticatedAliasSettingsMembersInvitesRouteImport.update({
    id: '/members/invites',
    path: '/members/invites',
    getParentRoute: () => AuthenticatedAliasSettingsRoute,
  } as any)
const AuthenticatedAliasSettingsMembersMemberIdRoute =
  AuthenticatedAliasSettingsMembersMemberIdRouteImport.update({
    id: '/members/$memberId',
    path: '/members/$memberId',
    getParentRoute: () => AuthenticatedAliasSettingsRoute,
  } as any)
const AuthenticatedAliasSettingsGroupsGroupIdRoute =
  AuthenticatedAliasSettingsGroupsGroupIdRouteImport.update({
    id: '/groups/$groupId',
    path: '/groups/$groupId',
    getParentRoute: () => AuthenticatedAliasSettingsRoute,
  } as any)
const AuthenticatedAliasSettingsChannelsChannelIdRoute =
  AuthenticatedAliasSettingsChannelsChannelIdRouteImport.update({
    id: '/channels/$channelId',
    path: '/channels/$channelId',
    getParentRoute: () => AuthenticatedAliasSettingsRoute,
  } as any)
const AuthenticatedAliasSettingsApiTokensNewRoute =
  AuthenticatedAliasSettingsApiTokensNewRouteImport.update({
    id: '/api-tokens/new',
    path: '/api-tokens/new',
    getParentRoute: () => AuthenticatedAliasSettingsRoute,
  } as any)
const AuthenticatedAliasSettingsAlertsAlertIdRoute =
  AuthenticatedAliasSettingsAlertsAlertIdRouteImport.update({
    id: '/alerts/$alertId',
    path: '/alerts/$alertId',
    getParentRoute: () => AuthenticatedAliasSettingsRoute,
  } as any)
const AuthenticatedAliasPrintEvaluationsEvaluationIdRoute =
  AuthenticatedAliasPrintEvaluationsEvaluationIdRouteImport.update({
    id: '/print/evaluations/$evaluationId',
    path: '/print/evaluations/$evaluationId',
    getParentRoute: () => AuthenticatedAliasRoute,
  } as any)
const AuthenticatedAliasIntegrationsIntegrationIdCreateContactRoute =
  AuthenticatedAliasIntegrationsIntegrationIdCreateContactRouteImport.update({
    id: '/integrations/$integrationId/create-contact',
    path: '/integrations/$integrationId/create-contact',
    getParentRoute: () => AuthenticatedAliasRoute,
  } as any)
const AuthenticatedAliasIntegrationsIntegrationIdCallbackRoute =
  AuthenticatedAliasIntegrationsIntegrationIdCallbackRouteImport.update({
    id: '/integrations/$integrationId/callback',
    path: '/integrations/$integrationId/callback',
    getParentRoute: () => AuthenticatedAliasRoute,
  } as any)
const AuthenticatedAliasIntegrationsIntegrationIdActivateRoute =
  AuthenticatedAliasIntegrationsIntegrationIdActivateRouteImport.update({
    id: '/integrations/$integrationId/activate',
    path: '/integrations/$integrationId/activate',
    getParentRoute: () => AuthenticatedAliasRoute,
  } as any)
const AuthenticatedAliasAppScorecardScorecardIdRoute =
  AuthenticatedAliasAppScorecardScorecardIdRouteImport.update({
    id: '/scorecard/$scorecardId',
    path: '/scorecard/$scorecardId',
    getParentRoute: () => AuthenticatedAliasAppRoute,
  } as any)
const AuthenticatedAliasAppMembersMemberIdRoute =
  AuthenticatedAliasAppMembersMemberIdRouteImport.update({
    id: '/members/$memberId',
    path: '/members/$memberId',
    getParentRoute: () => AuthenticatedAliasAppRoute,
  } as any)
const AuthenticatedAliasAppInteractionLookupRoute =
  AuthenticatedAliasAppInteractionLookupRouteImport.update({
    id: '/interaction/lookup',
    path: '/interaction/lookup',
    getParentRoute: () => AuthenticatedAliasAppRoute,
  } as any)
const AuthenticatedAliasAppContactLogsContactLogIdRoute =
  AuthenticatedAliasAppContactLogsContactLogIdRouteImport.update({
    id: '/contact-logs/$contactLogId',
    path: '/contact-logs/$contactLogId',
    getParentRoute: () => AuthenticatedAliasAppRoute,
  } as any)
const AuthenticatedAliasV2ScorecardScorecardIdIndexRoute =
  AuthenticatedAliasV2ScorecardScorecardIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedAliasV2ScorecardScorecardIdRoute,
  } as any)
const AuthenticatedAliasSettingsScorecardsScorecardIdIndexRoute =
  AuthenticatedAliasSettingsScorecardsScorecardIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedAliasSettingsScorecardsScorecardIdRoute,
  } as any)
const AuthenticatedAliasAppScorecardNewIndexRoute =
  AuthenticatedAliasAppScorecardNewIndexRouteImport.update({
    id: '/scorecard/new/',
    path: '/scorecard/new/',
    getParentRoute: () => AuthenticatedAliasAppRoute,
  } as any)
const AuthenticatedAliasAppScorecardScorecardIdIndexRoute =
  AuthenticatedAliasAppScorecardScorecardIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedAliasAppScorecardScorecardIdRoute,
  } as any)
const AuthenticatedAliasAppReportsPivotIndexRoute =
  AuthenticatedAliasAppReportsPivotIndexRouteImport.update({
    id: '/pivot/',
    path: '/pivot/',
    getParentRoute: () => AuthenticatedAliasAppReportsRoute,
  } as any)
const AuthenticatedAliasAppInteractionContactLogIdIndexRoute =
  AuthenticatedAliasAppInteractionContactLogIdIndexRouteImport.update({
    id: '/interaction/$contactLogId/',
    path: '/interaction/$contactLogId/',
    getParentRoute: () => AuthenticatedAliasAppRoute,
  } as any)
const AuthenticatedAliasAppIndicatorsIndicatorIdIndexRoute =
  AuthenticatedAliasAppIndicatorsIndicatorIdIndexRouteImport.update({
    id: '/indicators/$indicatorId/',
    path: '/indicators/$indicatorId/',
    getParentRoute: () => AuthenticatedAliasAppRoute,
  } as any)
const AuthenticatedAliasAppScorecardNewTemplateRoute =
  AuthenticatedAliasAppScorecardNewTemplateRouteImport.update({
    id: '/scorecard/new/template',
    path: '/scorecard/new/template',
    getParentRoute: () => AuthenticatedAliasAppRoute,
  } as any)
const AuthenticatedAliasAppScorecardScorecardIdEditRoute =
  AuthenticatedAliasAppScorecardScorecardIdEditRouteImport.update({
    id: '/edit',
    path: '/edit',
    getParentRoute: () => AuthenticatedAliasAppScorecardScorecardIdRoute,
  } as any)
const AuthenticatedAliasAppHighlightsHighlightCategoryIdNewRoute =
  AuthenticatedAliasAppHighlightsHighlightCategoryIdNewRouteImport.update({
    id: '/$highlightCategoryId/new',
    path: '/$highlightCategoryId/new',
    getParentRoute: () => AuthenticatedAliasAppHighlightsRoute,
  } as any)
const AuthenticatedAliasSettingsScorecardsScorecardIdSettingsIndexRoute =
  AuthenticatedAliasSettingsScorecardsScorecardIdSettingsIndexRouteImport.update(
    {
      id: '/settings/',
      path: '/settings/',
      getParentRoute: () =>
        AuthenticatedAliasSettingsScorecardsScorecardIdRoute,
    } as any,
  )
const AuthenticatedAliasSettingsScorecardsScorecardIdCriteriaIndexRoute =
  AuthenticatedAliasSettingsScorecardsScorecardIdCriteriaIndexRouteImport.update(
    {
      id: '/criteria/',
      path: '/criteria/',
      getParentRoute: () =>
        AuthenticatedAliasSettingsScorecardsScorecardIdRoute,
    } as any,
  )
const AuthenticatedAliasV2ScorecardScorecardIdCriteriaCriteriaIdRoute =
  AuthenticatedAliasV2ScorecardScorecardIdCriteriaCriteriaIdRouteImport.update({
    id: '/criteria/$criteriaId',
    path: '/criteria/$criteriaId',
    getParentRoute: () => AuthenticatedAliasV2ScorecardScorecardIdRoute,
  } as any)
const AuthenticatedAliasSettingsScorecardsScorecardIdCriteriaItemIdRoute =
  AuthenticatedAliasSettingsScorecardsScorecardIdCriteriaItemIdRouteImport.update(
    {
      id: '/criteria/$itemId',
      path: '/criteria/$itemId',
      getParentRoute: () =>
        AuthenticatedAliasSettingsScorecardsScorecardIdRoute,
    } as any,
  )
const AuthenticatedAliasAppScorecardScorecardIdEditIndex2Route =
  AuthenticatedAliasAppScorecardScorecardIdEditIndex2RouteImport.update({
    id: '/index2',
    path: '/index2',
    getParentRoute: () => AuthenticatedAliasAppScorecardScorecardIdEditRoute,
  } as any)
const AuthenticatedAliasAppScorecardScorecardIdEditCriteriaIdRoute =
  AuthenticatedAliasAppScorecardScorecardIdEditCriteriaIdRouteImport.update({
    id: '/$criteriaId',
    path: '/$criteriaId',
    getParentRoute: () => AuthenticatedAliasAppScorecardScorecardIdEditRoute,
  } as any)
const AuthenticatedAliasAppInteractionContactLogIdDisputeEvaluationIdRoute =
  AuthenticatedAliasAppInteractionContactLogIdDisputeEvaluationIdRouteImport.update(
    {
      id: '/interaction/$contactLogId/dispute/$evaluationId',
      path: '/interaction/$contactLogId/dispute/$evaluationId',
      getParentRoute: () => AuthenticatedAliasAppRoute,
    } as any,
  )
const AuthenticatedAliasAppHighlightsHighlightCategoryIdEditHighlightIdRoute =
  AuthenticatedAliasAppHighlightsHighlightCategoryIdEditHighlightIdRouteImport.update(
    {
      id: '/$highlightCategoryId/edit/$highlightId',
      path: '/$highlightCategoryId/edit/$highlightId',
      getParentRoute: () => AuthenticatedAliasAppHighlightsRoute,
    } as any,
  )
const AuthenticatedAliasSettingsScorecardsScorecardIdCriteriaNewSectionIdRoute =
  AuthenticatedAliasSettingsScorecardsScorecardIdCriteriaNewSectionIdRouteImport.update(
    {
      id: '/criteria/new/$sectionId',
      path: '/criteria/new/$sectionId',
      getParentRoute: () =>
        AuthenticatedAliasSettingsScorecardsScorecardIdRoute,
    } as any,
  )

export interface FileRoutesByFullPath {
  '/': typeof AuthenticatedIndexRoute
  '/$alias': typeof AuthenticatedAliasAppRouteWithChildren
  '/login': typeof PublicLoginRoute
  '/logout': typeof PublicLogoutRoute
  '/$alias/settings': typeof AuthenticatedAliasSettingsRouteWithChildren
  '/$alias/v2': typeof AuthenticatedAliasV2RouteWithChildren
  '/oauth/authorize': typeof AuthenticatedOauthAuthorizeRoute
  '/welcome/organization-details': typeof AuthenticatedWelcomeOrganizationDetailsRoute
  '/auth/callback': typeof PublicAuthCallbackRoute
  '/auth/code': typeof PublicAuthCodeRoute
  '/signup/code': typeof PublicSignupCodeRoute
  '/signup/organization': typeof PublicSignupOrganizationRoute
  '/register/': typeof PublicRegisterIndexRoute
  '/signup/': typeof PublicSignupIndexRoute
  '/$alias/highlights': typeof AuthenticatedAliasAppHighlightsRouteWithChildren
  '/$alias/reports': typeof AuthenticatedAliasAppReportsRouteWithChildren
  '/$alias/settings/goals': typeof AuthenticatedAliasSettingsGoalsRoute
  '/$alias/setup/customize': typeof AuthenticatedAliasSetupCustomizeRoute
  '/$alias/setup/upload': typeof AuthenticatedAliasSetupUploadRoute
  '/$alias/v2/generate': typeof AuthenticatedAliasV2GenerateRoute
  '/org/$orgId/$': typeof AuthenticatedOrgOrgIdSplatRoute
  '/$alias/': typeof AuthenticatedAliasAppIndexRoute
  '/$alias/settings/': typeof AuthenticatedAliasSettingsIndexRoute
  '/$alias/contact-logs/$contactLogId': typeof AuthenticatedAliasAppContactLogsContactLogIdRoute
  '/$alias/interaction/lookup': typeof AuthenticatedAliasAppInteractionLookupRoute
  '/$alias/members/$memberId': typeof AuthenticatedAliasAppMembersMemberIdRoute
  '/$alias/scorecard/$scorecardId': typeof AuthenticatedAliasAppScorecardScorecardIdRouteWithChildren
  '/$alias/integrations/$integrationId/activate': typeof AuthenticatedAliasIntegrationsIntegrationIdActivateRoute
  '/$alias/integrations/$integrationId/callback': typeof AuthenticatedAliasIntegrationsIntegrationIdCallbackRoute
  '/$alias/integrations/$integrationId/create-contact': typeof AuthenticatedAliasIntegrationsIntegrationIdCreateContactRoute
  '/$alias/print/evaluations/$evaluationId': typeof AuthenticatedAliasPrintEvaluationsEvaluationIdRoute
  '/$alias/settings/alerts/$alertId': typeof AuthenticatedAliasSettingsAlertsAlertIdRoute
  '/$alias/settings/api-tokens/new': typeof AuthenticatedAliasSettingsApiTokensNewRoute
  '/$alias/settings/channels/$channelId': typeof AuthenticatedAliasSettingsChannelsChannelIdRoute
  '/$alias/settings/groups/$groupId': typeof AuthenticatedAliasSettingsGroupsGroupIdRoute
  '/$alias/settings/members/$memberId': typeof AuthenticatedAliasSettingsMembersMemberIdRoute
  '/$alias/settings/members/invites': typeof AuthenticatedAliasSettingsMembersInvitesRoute
  '/$alias/settings/roles/$roleId': typeof AuthenticatedAliasSettingsRolesRoleIdRoute
  '/$alias/settings/scorecards/$scorecardId': typeof AuthenticatedAliasSettingsScorecardsScorecardIdRouteWithChildren
  '/$alias/settings/workspaces/$workspaceId': typeof AuthenticatedAliasSettingsWorkspacesWorkspaceIdRoute
  '/$alias/v2/scorecard/$scorecardId': typeof AuthenticatedAliasV2ScorecardScorecardIdRouteWithChildren
  '/o/r/g/$': typeof AuthenticatedORGSplatRoute
  '/$alias/explore/': typeof AuthenticatedAliasAppExploreIndexRoute
  '/$alias/highlights/': typeof AuthenticatedAliasAppHighlightsIndexRoute
  '/$alias/indicators/': typeof AuthenticatedAliasAppIndicatorsIndexRoute
  '/$alias/leaderboard/': typeof AuthenticatedAliasAppLeaderboardIndexRoute
  '/$alias/members/': typeof AuthenticatedAliasAppMembersIndexRoute
  '/$alias/scorecards/': typeof AuthenticatedAliasAppScorecardsIndexRoute
  '/$alias/search/': typeof AuthenticatedAliasAppSearchIndexRoute
  '/$alias/settings/alerts/': typeof AuthenticatedAliasSettingsAlertsIndexRoute
  '/$alias/settings/api-tokens/': typeof AuthenticatedAliasSettingsApiTokensIndexRoute
  '/$alias/settings/auto-qa-preferences/': typeof AuthenticatedAliasSettingsAutoQaPreferencesIndexRoute
  '/$alias/settings/billing/': typeof AuthenticatedAliasSettingsBillingIndexRoute
  '/$alias/settings/channels/': typeof AuthenticatedAliasSettingsChannelsIndexRoute
  '/$alias/settings/flags/': typeof AuthenticatedAliasSettingsFlagsIndexRoute
  '/$alias/settings/groups/': typeof AuthenticatedAliasSettingsGroupsIndexRoute
  '/$alias/settings/intents/': typeof AuthenticatedAliasSettingsIntentsIndexRoute
  '/$alias/settings/members/': typeof AuthenticatedAliasSettingsMembersIndexRoute
  '/$alias/settings/metrics/': typeof AuthenticatedAliasSettingsMetricsIndexRoute
  '/$alias/settings/organization/': typeof AuthenticatedAliasSettingsOrganizationIndexRoute
  '/$alias/settings/profile/': typeof AuthenticatedAliasSettingsProfileIndexRoute
  '/$alias/settings/roles/': typeof AuthenticatedAliasSettingsRolesIndexRoute
  '/$alias/settings/scorecards/': typeof AuthenticatedAliasSettingsScorecardsIndexRoute
  '/$alias/settings/topics/': typeof AuthenticatedAliasSettingsTopicsIndexRoute
  '/$alias/settings/transcription/': typeof AuthenticatedAliasSettingsTranscriptionIndexRoute
  '/$alias/settings/workspaces/': typeof AuthenticatedAliasSettingsWorkspacesIndexRoute
  '/$alias/highlights/$highlightCategoryId/new': typeof AuthenticatedAliasAppHighlightsHighlightCategoryIdNewRoute
  '/$alias/scorecard/$scorecardId/edit': typeof AuthenticatedAliasAppScorecardScorecardIdEditRouteWithChildren
  '/$alias/scorecard/new/template': typeof AuthenticatedAliasAppScorecardNewTemplateRoute
  '/$alias/indicators/$indicatorId/': typeof AuthenticatedAliasAppIndicatorsIndicatorIdIndexRoute
  '/$alias/interaction/$contactLogId/': typeof AuthenticatedAliasAppInteractionContactLogIdIndexRoute
  '/$alias/reports/pivot/': typeof AuthenticatedAliasAppReportsPivotIndexRoute
  '/$alias/scorecard/$scorecardId/': typeof AuthenticatedAliasAppScorecardScorecardIdIndexRoute
  '/$alias/scorecard/new/': typeof AuthenticatedAliasAppScorecardNewIndexRoute
  '/$alias/settings/scorecards/$scorecardId/': typeof AuthenticatedAliasSettingsScorecardsScorecardIdIndexRoute
  '/$alias/v2/scorecard/$scorecardId/': typeof AuthenticatedAliasV2ScorecardScorecardIdIndexRoute
  '/$alias/highlights/$highlightCategoryId/edit/$highlightId': typeof AuthenticatedAliasAppHighlightsHighlightCategoryIdEditHighlightIdRoute
  '/$alias/interaction/$contactLogId/dispute/$evaluationId': typeof AuthenticatedAliasAppInteractionContactLogIdDisputeEvaluationIdRoute
  '/$alias/scorecard/$scorecardId/edit/$criteriaId': typeof AuthenticatedAliasAppScorecardScorecardIdEditCriteriaIdRoute
  '/$alias/scorecard/$scorecardId/edit/index2': typeof AuthenticatedAliasAppScorecardScorecardIdEditIndex2Route
  '/$alias/settings/scorecards/$scorecardId/criteria/$itemId': typeof AuthenticatedAliasSettingsScorecardsScorecardIdCriteriaItemIdRoute
  '/$alias/v2/scorecard/$scorecardId/criteria/$criteriaId': typeof AuthenticatedAliasV2ScorecardScorecardIdCriteriaCriteriaIdRoute
  '/$alias/settings/scorecards/$scorecardId/criteria/': typeof AuthenticatedAliasSettingsScorecardsScorecardIdCriteriaIndexRoute
  '/$alias/settings/scorecards/$scorecardId/settings/': typeof AuthenticatedAliasSettingsScorecardsScorecardIdSettingsIndexRoute
  '/$alias/settings/scorecards/$scorecardId/criteria/new/$sectionId': typeof AuthenticatedAliasSettingsScorecardsScorecardIdCriteriaNewSectionIdRoute
}
export interface FileRoutesByTo {
  '/$alias': typeof AuthenticatedAliasAppIndexRoute
  '/login': typeof PublicLoginRoute
  '/logout': typeof PublicLogoutRoute
  '/': typeof AuthenticatedIndexRoute
  '/$alias/v2': typeof AuthenticatedAliasV2RouteWithChildren
  '/oauth/authorize': typeof AuthenticatedOauthAuthorizeRoute
  '/welcome/organization-details': typeof AuthenticatedWelcomeOrganizationDetailsRoute
  '/auth/callback': typeof PublicAuthCallbackRoute
  '/auth/code': typeof PublicAuthCodeRoute
  '/signup/code': typeof PublicSignupCodeRoute
  '/signup/organization': typeof PublicSignupOrganizationRoute
  '/register': typeof PublicRegisterIndexRoute
  '/signup': typeof PublicSignupIndexRoute
  '/$alias/reports': typeof AuthenticatedAliasAppReportsRouteWithChildren
  '/$alias/settings/goals': typeof AuthenticatedAliasSettingsGoalsRoute
  '/$alias/setup/customize': typeof AuthenticatedAliasSetupCustomizeRoute
  '/$alias/setup/upload': typeof AuthenticatedAliasSetupUploadRoute
  '/$alias/v2/generate': typeof AuthenticatedAliasV2GenerateRoute
  '/org/$orgId/$': typeof AuthenticatedOrgOrgIdSplatRoute
  '/$alias/settings': typeof AuthenticatedAliasSettingsIndexRoute
  '/$alias/contact-logs/$contactLogId': typeof AuthenticatedAliasAppContactLogsContactLogIdRoute
  '/$alias/interaction/lookup': typeof AuthenticatedAliasAppInteractionLookupRoute
  '/$alias/members/$memberId': typeof AuthenticatedAliasAppMembersMemberIdRoute
  '/$alias/integrations/$integrationId/activate': typeof AuthenticatedAliasIntegrationsIntegrationIdActivateRoute
  '/$alias/integrations/$integrationId/callback': typeof AuthenticatedAliasIntegrationsIntegrationIdCallbackRoute
  '/$alias/integrations/$integrationId/create-contact': typeof AuthenticatedAliasIntegrationsIntegrationIdCreateContactRoute
  '/$alias/print/evaluations/$evaluationId': typeof AuthenticatedAliasPrintEvaluationsEvaluationIdRoute
  '/$alias/settings/alerts/$alertId': typeof AuthenticatedAliasSettingsAlertsAlertIdRoute
  '/$alias/settings/api-tokens/new': typeof AuthenticatedAliasSettingsApiTokensNewRoute
  '/$alias/settings/channels/$channelId': typeof AuthenticatedAliasSettingsChannelsChannelIdRoute
  '/$alias/settings/groups/$groupId': typeof AuthenticatedAliasSettingsGroupsGroupIdRoute
  '/$alias/settings/members/$memberId': typeof AuthenticatedAliasSettingsMembersMemberIdRoute
  '/$alias/settings/members/invites': typeof AuthenticatedAliasSettingsMembersInvitesRoute
  '/$alias/settings/roles/$roleId': typeof AuthenticatedAliasSettingsRolesRoleIdRoute
  '/$alias/settings/workspaces/$workspaceId': typeof AuthenticatedAliasSettingsWorkspacesWorkspaceIdRoute
  '/o/r/g/$': typeof AuthenticatedORGSplatRoute
  '/$alias/explore': typeof AuthenticatedAliasAppExploreIndexRoute
  '/$alias/highlights': typeof AuthenticatedAliasAppHighlightsIndexRoute
  '/$alias/indicators': typeof AuthenticatedAliasAppIndicatorsIndexRoute
  '/$alias/leaderboard': typeof AuthenticatedAliasAppLeaderboardIndexRoute
  '/$alias/members': typeof AuthenticatedAliasAppMembersIndexRoute
  '/$alias/scorecards': typeof AuthenticatedAliasAppScorecardsIndexRoute
  '/$alias/search': typeof AuthenticatedAliasAppSearchIndexRoute
  '/$alias/settings/alerts': typeof AuthenticatedAliasSettingsAlertsIndexRoute
  '/$alias/settings/api-tokens': typeof AuthenticatedAliasSettingsApiTokensIndexRoute
  '/$alias/settings/auto-qa-preferences': typeof AuthenticatedAliasSettingsAutoQaPreferencesIndexRoute
  '/$alias/settings/billing': typeof AuthenticatedAliasSettingsBillingIndexRoute
  '/$alias/settings/channels': typeof AuthenticatedAliasSettingsChannelsIndexRoute
  '/$alias/settings/flags': typeof AuthenticatedAliasSettingsFlagsIndexRoute
  '/$alias/settings/groups': typeof AuthenticatedAliasSettingsGroupsIndexRoute
  '/$alias/settings/intents': typeof AuthenticatedAliasSettingsIntentsIndexRoute
  '/$alias/settings/members': typeof AuthenticatedAliasSettingsMembersIndexRoute
  '/$alias/settings/metrics': typeof AuthenticatedAliasSettingsMetricsIndexRoute
  '/$alias/settings/organization': typeof AuthenticatedAliasSettingsOrganizationIndexRoute
  '/$alias/settings/profile': typeof AuthenticatedAliasSettingsProfileIndexRoute
  '/$alias/settings/roles': typeof AuthenticatedAliasSettingsRolesIndexRoute
  '/$alias/settings/scorecards': typeof AuthenticatedAliasSettingsScorecardsIndexRoute
  '/$alias/settings/topics': typeof AuthenticatedAliasSettingsTopicsIndexRoute
  '/$alias/settings/transcription': typeof AuthenticatedAliasSettingsTranscriptionIndexRoute
  '/$alias/settings/workspaces': typeof AuthenticatedAliasSettingsWorkspacesIndexRoute
  '/$alias/highlights/$highlightCategoryId/new': typeof AuthenticatedAliasAppHighlightsHighlightCategoryIdNewRoute
  '/$alias/scorecard/$scorecardId/edit': typeof AuthenticatedAliasAppScorecardScorecardIdEditRouteWithChildren
  '/$alias/scorecard/new/template': typeof AuthenticatedAliasAppScorecardNewTemplateRoute
  '/$alias/indicators/$indicatorId': typeof AuthenticatedAliasAppIndicatorsIndicatorIdIndexRoute
  '/$alias/interaction/$contactLogId': typeof AuthenticatedAliasAppInteractionContactLogIdIndexRoute
  '/$alias/reports/pivot': typeof AuthenticatedAliasAppReportsPivotIndexRoute
  '/$alias/scorecard/$scorecardId': typeof AuthenticatedAliasAppScorecardScorecardIdIndexRoute
  '/$alias/scorecard/new': typeof AuthenticatedAliasAppScorecardNewIndexRoute
  '/$alias/settings/scorecards/$scorecardId': typeof AuthenticatedAliasSettingsScorecardsScorecardIdIndexRoute
  '/$alias/v2/scorecard/$scorecardId': typeof AuthenticatedAliasV2ScorecardScorecardIdIndexRoute
  '/$alias/highlights/$highlightCategoryId/edit/$highlightId': typeof AuthenticatedAliasAppHighlightsHighlightCategoryIdEditHighlightIdRoute
  '/$alias/interaction/$contactLogId/dispute/$evaluationId': typeof AuthenticatedAliasAppInteractionContactLogIdDisputeEvaluationIdRoute
  '/$alias/scorecard/$scorecardId/edit/$criteriaId': typeof AuthenticatedAliasAppScorecardScorecardIdEditCriteriaIdRoute
  '/$alias/scorecard/$scorecardId/edit/index2': typeof AuthenticatedAliasAppScorecardScorecardIdEditIndex2Route
  '/$alias/settings/scorecards/$scorecardId/criteria/$itemId': typeof AuthenticatedAliasSettingsScorecardsScorecardIdCriteriaItemIdRoute
  '/$alias/v2/scorecard/$scorecardId/criteria/$criteriaId': typeof AuthenticatedAliasV2ScorecardScorecardIdCriteriaCriteriaIdRoute
  '/$alias/settings/scorecards/$scorecardId/criteria': typeof AuthenticatedAliasSettingsScorecardsScorecardIdCriteriaIndexRoute
  '/$alias/settings/scorecards/$scorecardId/settings': typeof AuthenticatedAliasSettingsScorecardsScorecardIdSettingsIndexRoute
  '/$alias/settings/scorecards/$scorecardId/criteria/new/$sectionId': typeof AuthenticatedAliasSettingsScorecardsScorecardIdCriteriaNewSectionIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/_authenticated/$alias': typeof AuthenticatedAliasRouteWithChildren
  '/_public/login': typeof PublicLoginRoute
  '/_public/logout': typeof PublicLogoutRoute
  '/_authenticated/': typeof AuthenticatedIndexRoute
  '/_authenticated/$alias/_app': typeof AuthenticatedAliasAppRouteWithChildren
  '/_authenticated/$alias/settings': typeof AuthenticatedAliasSettingsRouteWithChildren
  '/_authenticated/$alias/v2': typeof AuthenticatedAliasV2RouteWithChildren
  '/_authenticated/oauth/authorize': typeof AuthenticatedOauthAuthorizeRoute
  '/_authenticated/welcome/organization-details': typeof AuthenticatedWelcomeOrganizationDetailsRoute
  '/_public/auth/callback': typeof PublicAuthCallbackRoute
  '/_public/auth/code': typeof PublicAuthCodeRoute
  '/_public/signup/code': typeof PublicSignupCodeRoute
  '/_public/signup/organization': typeof PublicSignupOrganizationRoute
  '/_public/register/': typeof PublicRegisterIndexRoute
  '/_public/signup/': typeof PublicSignupIndexRoute
  '/_authenticated/$alias/_app/highlights': typeof AuthenticatedAliasAppHighlightsRouteWithChildren
  '/_authenticated/$alias/_app/reports': typeof AuthenticatedAliasAppReportsRouteWithChildren
  '/_authenticated/$alias/settings/goals': typeof AuthenticatedAliasSettingsGoalsRoute
  '/_authenticated/$alias/setup/customize': typeof AuthenticatedAliasSetupCustomizeRoute
  '/_authenticated/$alias/setup/upload': typeof AuthenticatedAliasSetupUploadRoute
  '/_authenticated/$alias/v2/generate': typeof AuthenticatedAliasV2GenerateRoute
  '/_authenticated/org_/$orgId/$': typeof AuthenticatedOrgOrgIdSplatRoute
  '/_authenticated/$alias/_app/': typeof AuthenticatedAliasAppIndexRoute
  '/_authenticated/$alias/settings/': typeof AuthenticatedAliasSettingsIndexRoute
  '/_authenticated/$alias/_app/contact-logs/$contactLogId': typeof AuthenticatedAliasAppContactLogsContactLogIdRoute
  '/_authenticated/$alias/_app/interaction/lookup': typeof AuthenticatedAliasAppInteractionLookupRoute
  '/_authenticated/$alias/_app/members/$memberId': typeof AuthenticatedAliasAppMembersMemberIdRoute
  '/_authenticated/$alias/_app/scorecard/$scorecardId': typeof AuthenticatedAliasAppScorecardScorecardIdRouteWithChildren
  '/_authenticated/$alias/integrations/$integrationId/activate': typeof AuthenticatedAliasIntegrationsIntegrationIdActivateRoute
  '/_authenticated/$alias/integrations/$integrationId/callback': typeof AuthenticatedAliasIntegrationsIntegrationIdCallbackRoute
  '/_authenticated/$alias/integrations/$integrationId/create-contact': typeof AuthenticatedAliasIntegrationsIntegrationIdCreateContactRoute
  '/_authenticated/$alias/print/evaluations/$evaluationId': typeof AuthenticatedAliasPrintEvaluationsEvaluationIdRoute
  '/_authenticated/$alias/settings/alerts/$alertId': typeof AuthenticatedAliasSettingsAlertsAlertIdRoute
  '/_authenticated/$alias/settings/api-tokens/new': typeof AuthenticatedAliasSettingsApiTokensNewRoute
  '/_authenticated/$alias/settings/channels/$channelId': typeof AuthenticatedAliasSettingsChannelsChannelIdRoute
  '/_authenticated/$alias/settings/groups/$groupId': typeof AuthenticatedAliasSettingsGroupsGroupIdRoute
  '/_authenticated/$alias/settings/members/$memberId': typeof AuthenticatedAliasSettingsMembersMemberIdRoute
  '/_authenticated/$alias/settings/members/invites': typeof AuthenticatedAliasSettingsMembersInvitesRoute
  '/_authenticated/$alias/settings/roles/$roleId': typeof AuthenticatedAliasSettingsRolesRoleIdRoute
  '/_authenticated/$alias/settings/scorecards/$scorecardId': typeof AuthenticatedAliasSettingsScorecardsScorecardIdRouteWithChildren
  '/_authenticated/$alias/settings/workspaces/$workspaceId': typeof AuthenticatedAliasSettingsWorkspacesWorkspaceIdRoute
  '/_authenticated/$alias/v2/scorecard/$scorecardId': typeof AuthenticatedAliasV2ScorecardScorecardIdRouteWithChildren
  '/_authenticated/o/r/g/$': typeof AuthenticatedORGSplatRoute
  '/_authenticated/$alias/_app/explore/': typeof AuthenticatedAliasAppExploreIndexRoute
  '/_authenticated/$alias/_app/highlights/': typeof AuthenticatedAliasAppHighlightsIndexRoute
  '/_authenticated/$alias/_app/indicators/': typeof AuthenticatedAliasAppIndicatorsIndexRoute
  '/_authenticated/$alias/_app/leaderboard/': typeof AuthenticatedAliasAppLeaderboardIndexRoute
  '/_authenticated/$alias/_app/members/': typeof AuthenticatedAliasAppMembersIndexRoute
  '/_authenticated/$alias/_app/scorecards/': typeof AuthenticatedAliasAppScorecardsIndexRoute
  '/_authenticated/$alias/_app/search/': typeof AuthenticatedAliasAppSearchIndexRoute
  '/_authenticated/$alias/settings/alerts/': typeof AuthenticatedAliasSettingsAlertsIndexRoute
  '/_authenticated/$alias/settings/api-tokens/': typeof AuthenticatedAliasSettingsApiTokensIndexRoute
  '/_authenticated/$alias/settings/auto-qa-preferences/': typeof AuthenticatedAliasSettingsAutoQaPreferencesIndexRoute
  '/_authenticated/$alias/settings/billing/': typeof AuthenticatedAliasSettingsBillingIndexRoute
  '/_authenticated/$alias/settings/channels/': typeof AuthenticatedAliasSettingsChannelsIndexRoute
  '/_authenticated/$alias/settings/flags/': typeof AuthenticatedAliasSettingsFlagsIndexRoute
  '/_authenticated/$alias/settings/groups/': typeof AuthenticatedAliasSettingsGroupsIndexRoute
  '/_authenticated/$alias/settings/intents/': typeof AuthenticatedAliasSettingsIntentsIndexRoute
  '/_authenticated/$alias/settings/members/': typeof AuthenticatedAliasSettingsMembersIndexRoute
  '/_authenticated/$alias/settings/metrics/': typeof AuthenticatedAliasSettingsMetricsIndexRoute
  '/_authenticated/$alias/settings/organization/': typeof AuthenticatedAliasSettingsOrganizationIndexRoute
  '/_authenticated/$alias/settings/profile/': typeof AuthenticatedAliasSettingsProfileIndexRoute
  '/_authenticated/$alias/settings/roles/': typeof AuthenticatedAliasSettingsRolesIndexRoute
  '/_authenticated/$alias/settings/scorecards/': typeof AuthenticatedAliasSettingsScorecardsIndexRoute
  '/_authenticated/$alias/settings/topics/': typeof AuthenticatedAliasSettingsTopicsIndexRoute
  '/_authenticated/$alias/settings/transcription/': typeof AuthenticatedAliasSettingsTranscriptionIndexRoute
  '/_authenticated/$alias/settings/workspaces/': typeof AuthenticatedAliasSettingsWorkspacesIndexRoute
  '/_authenticated/$alias/_app/highlights/$highlightCategoryId/new': typeof AuthenticatedAliasAppHighlightsHighlightCategoryIdNewRoute
  '/_authenticated/$alias/_app/scorecard/$scorecardId/edit': typeof AuthenticatedAliasAppScorecardScorecardIdEditRouteWithChildren
  '/_authenticated/$alias/_app/scorecard/new/template': typeof AuthenticatedAliasAppScorecardNewTemplateRoute
  '/_authenticated/$alias/_app/indicators/$indicatorId/': typeof AuthenticatedAliasAppIndicatorsIndicatorIdIndexRoute
  '/_authenticated/$alias/_app/interaction/$contactLogId/': typeof AuthenticatedAliasAppInteractionContactLogIdIndexRoute
  '/_authenticated/$alias/_app/reports/pivot/': typeof AuthenticatedAliasAppReportsPivotIndexRoute
  '/_authenticated/$alias/_app/scorecard/$scorecardId/': typeof AuthenticatedAliasAppScorecardScorecardIdIndexRoute
  '/_authenticated/$alias/_app/scorecard/new/': typeof AuthenticatedAliasAppScorecardNewIndexRoute
  '/_authenticated/$alias/settings/scorecards/$scorecardId/': typeof AuthenticatedAliasSettingsScorecardsScorecardIdIndexRoute
  '/_authenticated/$alias/v2/scorecard/$scorecardId/': typeof AuthenticatedAliasV2ScorecardScorecardIdIndexRoute
  '/_authenticated/$alias/_app/highlights/$highlightCategoryId/edit/$highlightId': typeof AuthenticatedAliasAppHighlightsHighlightCategoryIdEditHighlightIdRoute
  '/_authenticated/$alias/_app/interaction/$contactLogId/dispute/$evaluationId': typeof AuthenticatedAliasAppInteractionContactLogIdDisputeEvaluationIdRoute
  '/_authenticated/$alias/_app/scorecard/$scorecardId/edit/$criteriaId': typeof AuthenticatedAliasAppScorecardScorecardIdEditCriteriaIdRoute
  '/_authenticated/$alias/_app/scorecard/$scorecardId/edit/index2': typeof AuthenticatedAliasAppScorecardScorecardIdEditIndex2Route
  '/_authenticated/$alias/settings/scorecards/$scorecardId/criteria/$itemId': typeof AuthenticatedAliasSettingsScorecardsScorecardIdCriteriaItemIdRoute
  '/_authenticated/$alias/v2/scorecard/$scorecardId/criteria/$criteriaId': typeof AuthenticatedAliasV2ScorecardScorecardIdCriteriaCriteriaIdRoute
  '/_authenticated/$alias/settings/scorecards/$scorecardId/criteria/': typeof AuthenticatedAliasSettingsScorecardsScorecardIdCriteriaIndexRoute
  '/_authenticated/$alias/settings/scorecards/$scorecardId/settings/': typeof AuthenticatedAliasSettingsScorecardsScorecardIdSettingsIndexRoute
  '/_authenticated/$alias/settings/scorecards/$scorecardId/criteria/new/$sectionId': typeof AuthenticatedAliasSettingsScorecardsScorecardIdCriteriaNewSectionIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/$alias'
    | '/login'
    | '/logout'
    | '/$alias/settings'
    | '/$alias/v2'
    | '/oauth/authorize'
    | '/welcome/organization-details'
    | '/auth/callback'
    | '/auth/code'
    | '/signup/code'
    | '/signup/organization'
    | '/register/'
    | '/signup/'
    | '/$alias/highlights'
    | '/$alias/reports'
    | '/$alias/settings/goals'
    | '/$alias/setup/customize'
    | '/$alias/setup/upload'
    | '/$alias/v2/generate'
    | '/org/$orgId/$'
    | '/$alias/'
    | '/$alias/settings/'
    | '/$alias/contact-logs/$contactLogId'
    | '/$alias/interaction/lookup'
    | '/$alias/members/$memberId'
    | '/$alias/scorecard/$scorecardId'
    | '/$alias/integrations/$integrationId/activate'
    | '/$alias/integrations/$integrationId/callback'
    | '/$alias/integrations/$integrationId/create-contact'
    | '/$alias/print/evaluations/$evaluationId'
    | '/$alias/settings/alerts/$alertId'
    | '/$alias/settings/api-tokens/new'
    | '/$alias/settings/channels/$channelId'
    | '/$alias/settings/groups/$groupId'
    | '/$alias/settings/members/$memberId'
    | '/$alias/settings/members/invites'
    | '/$alias/settings/roles/$roleId'
    | '/$alias/settings/scorecards/$scorecardId'
    | '/$alias/settings/workspaces/$workspaceId'
    | '/$alias/v2/scorecard/$scorecardId'
    | '/o/r/g/$'
    | '/$alias/explore/'
    | '/$alias/highlights/'
    | '/$alias/indicators/'
    | '/$alias/leaderboard/'
    | '/$alias/members/'
    | '/$alias/scorecards/'
    | '/$alias/search/'
    | '/$alias/settings/alerts/'
    | '/$alias/settings/api-tokens/'
    | '/$alias/settings/auto-qa-preferences/'
    | '/$alias/settings/billing/'
    | '/$alias/settings/channels/'
    | '/$alias/settings/flags/'
    | '/$alias/settings/groups/'
    | '/$alias/settings/intents/'
    | '/$alias/settings/members/'
    | '/$alias/settings/metrics/'
    | '/$alias/settings/organization/'
    | '/$alias/settings/profile/'
    | '/$alias/settings/roles/'
    | '/$alias/settings/scorecards/'
    | '/$alias/settings/topics/'
    | '/$alias/settings/transcription/'
    | '/$alias/settings/workspaces/'
    | '/$alias/highlights/$highlightCategoryId/new'
    | '/$alias/scorecard/$scorecardId/edit'
    | '/$alias/scorecard/new/template'
    | '/$alias/indicators/$indicatorId/'
    | '/$alias/interaction/$contactLogId/'
    | '/$alias/reports/pivot/'
    | '/$alias/scorecard/$scorecardId/'
    | '/$alias/scorecard/new/'
    | '/$alias/settings/scorecards/$scorecardId/'
    | '/$alias/v2/scorecard/$scorecardId/'
    | '/$alias/highlights/$highlightCategoryId/edit/$highlightId'
    | '/$alias/interaction/$contactLogId/dispute/$evaluationId'
    | '/$alias/scorecard/$scorecardId/edit/$criteriaId'
    | '/$alias/scorecard/$scorecardId/edit/index2'
    | '/$alias/settings/scorecards/$scorecardId/criteria/$itemId'
    | '/$alias/v2/scorecard/$scorecardId/criteria/$criteriaId'
    | '/$alias/settings/scorecards/$scorecardId/criteria/'
    | '/$alias/settings/scorecards/$scorecardId/settings/'
    | '/$alias/settings/scorecards/$scorecardId/criteria/new/$sectionId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/$alias'
    | '/login'
    | '/logout'
    | '/'
    | '/$alias/v2'
    | '/oauth/authorize'
    | '/welcome/organization-details'
    | '/auth/callback'
    | '/auth/code'
    | '/signup/code'
    | '/signup/organization'
    | '/register'
    | '/signup'
    | '/$alias/reports'
    | '/$alias/settings/goals'
    | '/$alias/setup/customize'
    | '/$alias/setup/upload'
    | '/$alias/v2/generate'
    | '/org/$orgId/$'
    | '/$alias/settings'
    | '/$alias/contact-logs/$contactLogId'
    | '/$alias/interaction/lookup'
    | '/$alias/members/$memberId'
    | '/$alias/integrations/$integrationId/activate'
    | '/$alias/integrations/$integrationId/callback'
    | '/$alias/integrations/$integrationId/create-contact'
    | '/$alias/print/evaluations/$evaluationId'
    | '/$alias/settings/alerts/$alertId'
    | '/$alias/settings/api-tokens/new'
    | '/$alias/settings/channels/$channelId'
    | '/$alias/settings/groups/$groupId'
    | '/$alias/settings/members/$memberId'
    | '/$alias/settings/members/invites'
    | '/$alias/settings/roles/$roleId'
    | '/$alias/settings/workspaces/$workspaceId'
    | '/o/r/g/$'
    | '/$alias/explore'
    | '/$alias/highlights'
    | '/$alias/indicators'
    | '/$alias/leaderboard'
    | '/$alias/members'
    | '/$alias/scorecards'
    | '/$alias/search'
    | '/$alias/settings/alerts'
    | '/$alias/settings/api-tokens'
    | '/$alias/settings/auto-qa-preferences'
    | '/$alias/settings/billing'
    | '/$alias/settings/channels'
    | '/$alias/settings/flags'
    | '/$alias/settings/groups'
    | '/$alias/settings/intents'
    | '/$alias/settings/members'
    | '/$alias/settings/metrics'
    | '/$alias/settings/organization'
    | '/$alias/settings/profile'
    | '/$alias/settings/roles'
    | '/$alias/settings/scorecards'
    | '/$alias/settings/topics'
    | '/$alias/settings/transcription'
    | '/$alias/settings/workspaces'
    | '/$alias/highlights/$highlightCategoryId/new'
    | '/$alias/scorecard/$scorecardId/edit'
    | '/$alias/scorecard/new/template'
    | '/$alias/indicators/$indicatorId'
    | '/$alias/interaction/$contactLogId'
    | '/$alias/reports/pivot'
    | '/$alias/scorecard/$scorecardId'
    | '/$alias/scorecard/new'
    | '/$alias/settings/scorecards/$scorecardId'
    | '/$alias/v2/scorecard/$scorecardId'
    | '/$alias/highlights/$highlightCategoryId/edit/$highlightId'
    | '/$alias/interaction/$contactLogId/dispute/$evaluationId'
    | '/$alias/scorecard/$scorecardId/edit/$criteriaId'
    | '/$alias/scorecard/$scorecardId/edit/index2'
    | '/$alias/settings/scorecards/$scorecardId/criteria/$itemId'
    | '/$alias/v2/scorecard/$scorecardId/criteria/$criteriaId'
    | '/$alias/settings/scorecards/$scorecardId/criteria'
    | '/$alias/settings/scorecards/$scorecardId/settings'
    | '/$alias/settings/scorecards/$scorecardId/criteria/new/$sectionId'
  id:
    | '__root__'
    | '/_authenticated'
    | '/_authenticated/$alias'
    | '/_public/login'
    | '/_public/logout'
    | '/_authenticated/'
    | '/_authenticated/$alias/_app'
    | '/_authenticated/$alias/settings'
    | '/_authenticated/$alias/v2'
    | '/_authenticated/oauth/authorize'
    | '/_authenticated/welcome/organization-details'
    | '/_public/auth/callback'
    | '/_public/auth/code'
    | '/_public/signup/code'
    | '/_public/signup/organization'
    | '/_public/register/'
    | '/_public/signup/'
    | '/_authenticated/$alias/_app/highlights'
    | '/_authenticated/$alias/_app/reports'
    | '/_authenticated/$alias/settings/goals'
    | '/_authenticated/$alias/setup/customize'
    | '/_authenticated/$alias/setup/upload'
    | '/_authenticated/$alias/v2/generate'
    | '/_authenticated/org_/$orgId/$'
    | '/_authenticated/$alias/_app/'
    | '/_authenticated/$alias/settings/'
    | '/_authenticated/$alias/_app/contact-logs/$contactLogId'
    | '/_authenticated/$alias/_app/interaction/lookup'
    | '/_authenticated/$alias/_app/members/$memberId'
    | '/_authenticated/$alias/_app/scorecard/$scorecardId'
    | '/_authenticated/$alias/integrations/$integrationId/activate'
    | '/_authenticated/$alias/integrations/$integrationId/callback'
    | '/_authenticated/$alias/integrations/$integrationId/create-contact'
    | '/_authenticated/$alias/print/evaluations/$evaluationId'
    | '/_authenticated/$alias/settings/alerts/$alertId'
    | '/_authenticated/$alias/settings/api-tokens/new'
    | '/_authenticated/$alias/settings/channels/$channelId'
    | '/_authenticated/$alias/settings/groups/$groupId'
    | '/_authenticated/$alias/settings/members/$memberId'
    | '/_authenticated/$alias/settings/members/invites'
    | '/_authenticated/$alias/settings/roles/$roleId'
    | '/_authenticated/$alias/settings/scorecards/$scorecardId'
    | '/_authenticated/$alias/settings/workspaces/$workspaceId'
    | '/_authenticated/$alias/v2/scorecard/$scorecardId'
    | '/_authenticated/o/r/g/$'
    | '/_authenticated/$alias/_app/explore/'
    | '/_authenticated/$alias/_app/highlights/'
    | '/_authenticated/$alias/_app/indicators/'
    | '/_authenticated/$alias/_app/leaderboard/'
    | '/_authenticated/$alias/_app/members/'
    | '/_authenticated/$alias/_app/scorecards/'
    | '/_authenticated/$alias/_app/search/'
    | '/_authenticated/$alias/settings/alerts/'
    | '/_authenticated/$alias/settings/api-tokens/'
    | '/_authenticated/$alias/settings/auto-qa-preferences/'
    | '/_authenticated/$alias/settings/billing/'
    | '/_authenticated/$alias/settings/channels/'
    | '/_authenticated/$alias/settings/flags/'
    | '/_authenticated/$alias/settings/groups/'
    | '/_authenticated/$alias/settings/intents/'
    | '/_authenticated/$alias/settings/members/'
    | '/_authenticated/$alias/settings/metrics/'
    | '/_authenticated/$alias/settings/organization/'
    | '/_authenticated/$alias/settings/profile/'
    | '/_authenticated/$alias/settings/roles/'
    | '/_authenticated/$alias/settings/scorecards/'
    | '/_authenticated/$alias/settings/topics/'
    | '/_authenticated/$alias/settings/transcription/'
    | '/_authenticated/$alias/settings/workspaces/'
    | '/_authenticated/$alias/_app/highlights/$highlightCategoryId/new'
    | '/_authenticated/$alias/_app/scorecard/$scorecardId/edit'
    | '/_authenticated/$alias/_app/scorecard/new/template'
    | '/_authenticated/$alias/_app/indicators/$indicatorId/'
    | '/_authenticated/$alias/_app/interaction/$contactLogId/'
    | '/_authenticated/$alias/_app/reports/pivot/'
    | '/_authenticated/$alias/_app/scorecard/$scorecardId/'
    | '/_authenticated/$alias/_app/scorecard/new/'
    | '/_authenticated/$alias/settings/scorecards/$scorecardId/'
    | '/_authenticated/$alias/v2/scorecard/$scorecardId/'
    | '/_authenticated/$alias/_app/highlights/$highlightCategoryId/edit/$highlightId'
    | '/_authenticated/$alias/_app/interaction/$contactLogId/dispute/$evaluationId'
    | '/_authenticated/$alias/_app/scorecard/$scorecardId/edit/$criteriaId'
    | '/_authenticated/$alias/_app/scorecard/$scorecardId/edit/index2'
    | '/_authenticated/$alias/settings/scorecards/$scorecardId/criteria/$itemId'
    | '/_authenticated/$alias/v2/scorecard/$scorecardId/criteria/$criteriaId'
    | '/_authenticated/$alias/settings/scorecards/$scorecardId/criteria/'
    | '/_authenticated/$alias/settings/scorecards/$scorecardId/settings/'
    | '/_authenticated/$alias/settings/scorecards/$scorecardId/criteria/new/$sectionId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  PublicLoginRoute: typeof PublicLoginRoute
  PublicLogoutRoute: typeof PublicLogoutRoute
  PublicAuthCallbackRoute: typeof PublicAuthCallbackRoute
  PublicAuthCodeRoute: typeof PublicAuthCodeRoute
  PublicSignupCodeRoute: typeof PublicSignupCodeRoute
  PublicSignupOrganizationRoute: typeof PublicSignupOrganizationRoute
  PublicRegisterIndexRoute: typeof PublicRegisterIndexRoute
  PublicSignupIndexRoute: typeof PublicSignupIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/': {
      id: '/_authenticated/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_public/logout': {
      id: '/_public/logout'
      path: '/logout'
      fullPath: '/logout'
      preLoaderRoute: typeof PublicLogoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_public/login': {
      id: '/_public/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof PublicLoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/$alias': {
      id: '/_authenticated/$alias'
      path: '/$alias'
      fullPath: '/$alias'
      preLoaderRoute: typeof AuthenticatedAliasRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_public/signup/': {
      id: '/_public/signup/'
      path: '/signup'
      fullPath: '/signup/'
      preLoaderRoute: typeof PublicSignupIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_public/register/': {
      id: '/_public/register/'
      path: '/register'
      fullPath: '/register/'
      preLoaderRoute: typeof PublicRegisterIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_public/signup/organization': {
      id: '/_public/signup/organization'
      path: '/signup/organization'
      fullPath: '/signup/organization'
      preLoaderRoute: typeof PublicSignupOrganizationRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_public/signup/code': {
      id: '/_public/signup/code'
      path: '/signup/code'
      fullPath: '/signup/code'
      preLoaderRoute: typeof PublicSignupCodeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_public/auth/code': {
      id: '/_public/auth/code'
      path: '/auth/code'
      fullPath: '/auth/code'
      preLoaderRoute: typeof PublicAuthCodeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_public/auth/callback': {
      id: '/_public/auth/callback'
      path: '/auth/callback'
      fullPath: '/auth/callback'
      preLoaderRoute: typeof PublicAuthCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/welcome/organization-details': {
      id: '/_authenticated/welcome/organization-details'
      path: '/welcome/organization-details'
      fullPath: '/welcome/organization-details'
      preLoaderRoute: typeof AuthenticatedWelcomeOrganizationDetailsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/oauth/authorize': {
      id: '/_authenticated/oauth/authorize'
      path: '/oauth/authorize'
      fullPath: '/oauth/authorize'
      preLoaderRoute: typeof AuthenticatedOauthAuthorizeRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/$alias/v2': {
      id: '/_authenticated/$alias/v2'
      path: '/v2'
      fullPath: '/$alias/v2'
      preLoaderRoute: typeof AuthenticatedAliasV2RouteImport
      parentRoute: typeof AuthenticatedAliasRoute
    }
    '/_authenticated/$alias/settings': {
      id: '/_authenticated/$alias/settings'
      path: '/settings'
      fullPath: '/$alias/settings'
      preLoaderRoute: typeof AuthenticatedAliasSettingsRouteImport
      parentRoute: typeof AuthenticatedAliasRoute
    }
    '/_authenticated/$alias/_app': {
      id: '/_authenticated/$alias/_app'
      path: ''
      fullPath: '/$alias'
      preLoaderRoute: typeof AuthenticatedAliasAppRouteImport
      parentRoute: typeof AuthenticatedAliasRoute
    }
    '/_authenticated/$alias/settings/': {
      id: '/_authenticated/$alias/settings/'
      path: '/'
      fullPath: '/$alias/settings/'
      preLoaderRoute: typeof AuthenticatedAliasSettingsIndexRouteImport
      parentRoute: typeof AuthenticatedAliasSettingsRoute
    }
    '/_authenticated/$alias/_app/': {
      id: '/_authenticated/$alias/_app/'
      path: '/'
      fullPath: '/$alias/'
      preLoaderRoute: typeof AuthenticatedAliasAppIndexRouteImport
      parentRoute: typeof AuthenticatedAliasAppRoute
    }
    '/_authenticated/org_/$orgId/$': {
      id: '/_authenticated/org_/$orgId/$'
      path: '/org/$orgId/$'
      fullPath: '/org/$orgId/$'
      preLoaderRoute: typeof AuthenticatedOrgOrgIdSplatRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/$alias/v2/generate': {
      id: '/_authenticated/$alias/v2/generate'
      path: '/generate'
      fullPath: '/$alias/v2/generate'
      preLoaderRoute: typeof AuthenticatedAliasV2GenerateRouteImport
      parentRoute: typeof AuthenticatedAliasV2Route
    }
    '/_authenticated/$alias/setup/upload': {
      id: '/_authenticated/$alias/setup/upload'
      path: '/setup/upload'
      fullPath: '/$alias/setup/upload'
      preLoaderRoute: typeof AuthenticatedAliasSetupUploadRouteImport
      parentRoute: typeof AuthenticatedAliasRoute
    }
    '/_authenticated/$alias/setup/customize': {
      id: '/_authenticated/$alias/setup/customize'
      path: '/setup/customize'
      fullPath: '/$alias/setup/customize'
      preLoaderRoute: typeof AuthenticatedAliasSetupCustomizeRouteImport
      parentRoute: typeof AuthenticatedAliasRoute
    }
    '/_authenticated/$alias/settings/goals': {
      id: '/_authenticated/$alias/settings/goals'
      path: '/goals'
      fullPath: '/$alias/settings/goals'
      preLoaderRoute: typeof AuthenticatedAliasSettingsGoalsRouteImport
      parentRoute: typeof AuthenticatedAliasSettingsRoute
    }
    '/_authenticated/$alias/_app/reports': {
      id: '/_authenticated/$alias/_app/reports'
      path: '/reports'
      fullPath: '/$alias/reports'
      preLoaderRoute: typeof AuthenticatedAliasAppReportsRouteImport
      parentRoute: typeof AuthenticatedAliasAppRoute
    }
    '/_authenticated/$alias/_app/highlights': {
      id: '/_authenticated/$alias/_app/highlights'
      path: '/highlights'
      fullPath: '/$alias/highlights'
      preLoaderRoute: typeof AuthenticatedAliasAppHighlightsRouteImport
      parentRoute: typeof AuthenticatedAliasAppRoute
    }
    '/_authenticated/$alias/settings/workspaces/': {
      id: '/_authenticated/$alias/settings/workspaces/'
      path: '/workspaces'
      fullPath: '/$alias/settings/workspaces/'
      preLoaderRoute: typeof AuthenticatedAliasSettingsWorkspacesIndexRouteImport
      parentRoute: typeof AuthenticatedAliasSettingsRoute
    }
    '/_authenticated/$alias/settings/transcription/': {
      id: '/_authenticated/$alias/settings/transcription/'
      path: '/transcription'
      fullPath: '/$alias/settings/transcription/'
      preLoaderRoute: typeof AuthenticatedAliasSettingsTranscriptionIndexRouteImport
      parentRoute: typeof AuthenticatedAliasSettingsRoute
    }
    '/_authenticated/$alias/settings/topics/': {
      id: '/_authenticated/$alias/settings/topics/'
      path: '/topics'
      fullPath: '/$alias/settings/topics/'
      preLoaderRoute: typeof AuthenticatedAliasSettingsTopicsIndexRouteImport
      parentRoute: typeof AuthenticatedAliasSettingsRoute
    }
    '/_authenticated/$alias/settings/scorecards/': {
      id: '/_authenticated/$alias/settings/scorecards/'
      path: '/scorecards'
      fullPath: '/$alias/settings/scorecards/'
      preLoaderRoute: typeof AuthenticatedAliasSettingsScorecardsIndexRouteImport
      parentRoute: typeof AuthenticatedAliasSettingsRoute
    }
    '/_authenticated/$alias/settings/roles/': {
      id: '/_authenticated/$alias/settings/roles/'
      path: '/roles'
      fullPath: '/$alias/settings/roles/'
      preLoaderRoute: typeof AuthenticatedAliasSettingsRolesIndexRouteImport
      parentRoute: typeof AuthenticatedAliasSettingsRoute
    }
    '/_authenticated/$alias/settings/profile/': {
      id: '/_authenticated/$alias/settings/profile/'
      path: '/profile'
      fullPath: '/$alias/settings/profile/'
      preLoaderRoute: typeof AuthenticatedAliasSettingsProfileIndexRouteImport
      parentRoute: typeof AuthenticatedAliasSettingsRoute
    }
    '/_authenticated/$alias/settings/organization/': {
      id: '/_authenticated/$alias/settings/organization/'
      path: '/organization'
      fullPath: '/$alias/settings/organization/'
      preLoaderRoute: typeof AuthenticatedAliasSettingsOrganizationIndexRouteImport
      parentRoute: typeof AuthenticatedAliasSettingsRoute
    }
    '/_authenticated/$alias/settings/metrics/': {
      id: '/_authenticated/$alias/settings/metrics/'
      path: '/metrics'
      fullPath: '/$alias/settings/metrics/'
      preLoaderRoute: typeof AuthenticatedAliasSettingsMetricsIndexRouteImport
      parentRoute: typeof AuthenticatedAliasSettingsRoute
    }
    '/_authenticated/$alias/settings/members/': {
      id: '/_authenticated/$alias/settings/members/'
      path: '/members'
      fullPath: '/$alias/settings/members/'
      preLoaderRoute: typeof AuthenticatedAliasSettingsMembersIndexRouteImport
      parentRoute: typeof AuthenticatedAliasSettingsRoute
    }
    '/_authenticated/$alias/settings/intents/': {
      id: '/_authenticated/$alias/settings/intents/'
      path: '/intents'
      fullPath: '/$alias/settings/intents/'
      preLoaderRoute: typeof AuthenticatedAliasSettingsIntentsIndexRouteImport
      parentRoute: typeof AuthenticatedAliasSettingsRoute
    }
    '/_authenticated/$alias/settings/groups/': {
      id: '/_authenticated/$alias/settings/groups/'
      path: '/groups'
      fullPath: '/$alias/settings/groups/'
      preLoaderRoute: typeof AuthenticatedAliasSettingsGroupsIndexRouteImport
      parentRoute: typeof AuthenticatedAliasSettingsRoute
    }
    '/_authenticated/$alias/settings/flags/': {
      id: '/_authenticated/$alias/settings/flags/'
      path: '/flags'
      fullPath: '/$alias/settings/flags/'
      preLoaderRoute: typeof AuthenticatedAliasSettingsFlagsIndexRouteImport
      parentRoute: typeof AuthenticatedAliasSettingsRoute
    }
    '/_authenticated/$alias/settings/channels/': {
      id: '/_authenticated/$alias/settings/channels/'
      path: '/channels'
      fullPath: '/$alias/settings/channels/'
      preLoaderRoute: typeof AuthenticatedAliasSettingsChannelsIndexRouteImport
      parentRoute: typeof AuthenticatedAliasSettingsRoute
    }
    '/_authenticated/$alias/settings/billing/': {
      id: '/_authenticated/$alias/settings/billing/'
      path: '/billing'
      fullPath: '/$alias/settings/billing/'
      preLoaderRoute: typeof AuthenticatedAliasSettingsBillingIndexRouteImport
      parentRoute: typeof AuthenticatedAliasSettingsRoute
    }
    '/_authenticated/$alias/settings/auto-qa-preferences/': {
      id: '/_authenticated/$alias/settings/auto-qa-preferences/'
      path: '/auto-qa-preferences'
      fullPath: '/$alias/settings/auto-qa-preferences/'
      preLoaderRoute: typeof AuthenticatedAliasSettingsAutoQaPreferencesIndexRouteImport
      parentRoute: typeof AuthenticatedAliasSettingsRoute
    }
    '/_authenticated/$alias/settings/api-tokens/': {
      id: '/_authenticated/$alias/settings/api-tokens/'
      path: '/api-tokens'
      fullPath: '/$alias/settings/api-tokens/'
      preLoaderRoute: typeof AuthenticatedAliasSettingsApiTokensIndexRouteImport
      parentRoute: typeof AuthenticatedAliasSettingsRoute
    }
    '/_authenticated/$alias/settings/alerts/': {
      id: '/_authenticated/$alias/settings/alerts/'
      path: '/alerts'
      fullPath: '/$alias/settings/alerts/'
      preLoaderRoute: typeof AuthenticatedAliasSettingsAlertsIndexRouteImport
      parentRoute: typeof AuthenticatedAliasSettingsRoute
    }
    '/_authenticated/$alias/_app/search/': {
      id: '/_authenticated/$alias/_app/search/'
      path: '/search'
      fullPath: '/$alias/search/'
      preLoaderRoute: typeof AuthenticatedAliasAppSearchIndexRouteImport
      parentRoute: typeof AuthenticatedAliasAppRoute
    }
    '/_authenticated/$alias/_app/scorecards/': {
      id: '/_authenticated/$alias/_app/scorecards/'
      path: '/scorecards'
      fullPath: '/$alias/scorecards/'
      preLoaderRoute: typeof AuthenticatedAliasAppScorecardsIndexRouteImport
      parentRoute: typeof AuthenticatedAliasAppRoute
    }
    '/_authenticated/$alias/_app/members/': {
      id: '/_authenticated/$alias/_app/members/'
      path: '/members'
      fullPath: '/$alias/members/'
      preLoaderRoute: typeof AuthenticatedAliasAppMembersIndexRouteImport
      parentRoute: typeof AuthenticatedAliasAppRoute
    }
    '/_authenticated/$alias/_app/leaderboard/': {
      id: '/_authenticated/$alias/_app/leaderboard/'
      path: '/leaderboard'
      fullPath: '/$alias/leaderboard/'
      preLoaderRoute: typeof AuthenticatedAliasAppLeaderboardIndexRouteImport
      parentRoute: typeof AuthenticatedAliasAppRoute
    }
    '/_authenticated/$alias/_app/indicators/': {
      id: '/_authenticated/$alias/_app/indicators/'
      path: '/indicators'
      fullPath: '/$alias/indicators/'
      preLoaderRoute: typeof AuthenticatedAliasAppIndicatorsIndexRouteImport
      parentRoute: typeof AuthenticatedAliasAppRoute
    }
    '/_authenticated/$alias/_app/highlights/': {
      id: '/_authenticated/$alias/_app/highlights/'
      path: '/'
      fullPath: '/$alias/highlights/'
      preLoaderRoute: typeof AuthenticatedAliasAppHighlightsIndexRouteImport
      parentRoute: typeof AuthenticatedAliasAppHighlightsRoute
    }
    '/_authenticated/$alias/_app/explore/': {
      id: '/_authenticated/$alias/_app/explore/'
      path: '/explore'
      fullPath: '/$alias/explore/'
      preLoaderRoute: typeof AuthenticatedAliasAppExploreIndexRouteImport
      parentRoute: typeof AuthenticatedAliasAppRoute
    }
    '/_authenticated/o/r/g/$': {
      id: '/_authenticated/o/r/g/$'
      path: '/o/r/g/$'
      fullPath: '/o/r/g/$'
      preLoaderRoute: typeof AuthenticatedORGSplatRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/$alias/v2/scorecard/$scorecardId': {
      id: '/_authenticated/$alias/v2/scorecard/$scorecardId'
      path: '/scorecard/$scorecardId'
      fullPath: '/$alias/v2/scorecard/$scorecardId'
      preLoaderRoute: typeof AuthenticatedAliasV2ScorecardScorecardIdRouteImport
      parentRoute: typeof AuthenticatedAliasV2Route
    }
    '/_authenticated/$alias/settings/workspaces/$workspaceId': {
      id: '/_authenticated/$alias/settings/workspaces/$workspaceId'
      path: '/workspaces/$workspaceId'
      fullPath: '/$alias/settings/workspaces/$workspaceId'
      preLoaderRoute: typeof AuthenticatedAliasSettingsWorkspacesWorkspaceIdRouteImport
      parentRoute: typeof AuthenticatedAliasSettingsRoute
    }
    '/_authenticated/$alias/settings/scorecards/$scorecardId': {
      id: '/_authenticated/$alias/settings/scorecards/$scorecardId'
      path: '/scorecards/$scorecardId'
      fullPath: '/$alias/settings/scorecards/$scorecardId'
      preLoaderRoute: typeof AuthenticatedAliasSettingsScorecardsScorecardIdRouteImport
      parentRoute: typeof AuthenticatedAliasSettingsRoute
    }
    '/_authenticated/$alias/settings/roles/$roleId': {
      id: '/_authenticated/$alias/settings/roles/$roleId'
      path: '/roles/$roleId'
      fullPath: '/$alias/settings/roles/$roleId'
      preLoaderRoute: typeof AuthenticatedAliasSettingsRolesRoleIdRouteImport
      parentRoute: typeof AuthenticatedAliasSettingsRoute
    }
    '/_authenticated/$alias/settings/members/invites': {
      id: '/_authenticated/$alias/settings/members/invites'
      path: '/members/invites'
      fullPath: '/$alias/settings/members/invites'
      preLoaderRoute: typeof AuthenticatedAliasSettingsMembersInvitesRouteImport
      parentRoute: typeof AuthenticatedAliasSettingsRoute
    }
    '/_authenticated/$alias/settings/members/$memberId': {
      id: '/_authenticated/$alias/settings/members/$memberId'
      path: '/members/$memberId'
      fullPath: '/$alias/settings/members/$memberId'
      preLoaderRoute: typeof AuthenticatedAliasSettingsMembersMemberIdRouteImport
      parentRoute: typeof AuthenticatedAliasSettingsRoute
    }
    '/_authenticated/$alias/settings/groups/$groupId': {
      id: '/_authenticated/$alias/settings/groups/$groupId'
      path: '/groups/$groupId'
      fullPath: '/$alias/settings/groups/$groupId'
      preLoaderRoute: typeof AuthenticatedAliasSettingsGroupsGroupIdRouteImport
      parentRoute: typeof AuthenticatedAliasSettingsRoute
    }
    '/_authenticated/$alias/settings/channels/$channelId': {
      id: '/_authenticated/$alias/settings/channels/$channelId'
      path: '/channels/$channelId'
      fullPath: '/$alias/settings/channels/$channelId'
      preLoaderRoute: typeof AuthenticatedAliasSettingsChannelsChannelIdRouteImport
      parentRoute: typeof AuthenticatedAliasSettingsRoute
    }
    '/_authenticated/$alias/settings/api-tokens/new': {
      id: '/_authenticated/$alias/settings/api-tokens/new'
      path: '/api-tokens/new'
      fullPath: '/$alias/settings/api-tokens/new'
      preLoaderRoute: typeof AuthenticatedAliasSettingsApiTokensNewRouteImport
      parentRoute: typeof AuthenticatedAliasSettingsRoute
    }
    '/_authenticated/$alias/settings/alerts/$alertId': {
      id: '/_authenticated/$alias/settings/alerts/$alertId'
      path: '/alerts/$alertId'
      fullPath: '/$alias/settings/alerts/$alertId'
      preLoaderRoute: typeof AuthenticatedAliasSettingsAlertsAlertIdRouteImport
      parentRoute: typeof AuthenticatedAliasSettingsRoute
    }
    '/_authenticated/$alias/print/evaluations/$evaluationId': {
      id: '/_authenticated/$alias/print/evaluations/$evaluationId'
      path: '/print/evaluations/$evaluationId'
      fullPath: '/$alias/print/evaluations/$evaluationId'
      preLoaderRoute: typeof AuthenticatedAliasPrintEvaluationsEvaluationIdRouteImport
      parentRoute: typeof AuthenticatedAliasRoute
    }
    '/_authenticated/$alias/integrations/$integrationId/create-contact': {
      id: '/_authenticated/$alias/integrations/$integrationId/create-contact'
      path: '/integrations/$integrationId/create-contact'
      fullPath: '/$alias/integrations/$integrationId/create-contact'
      preLoaderRoute: typeof AuthenticatedAliasIntegrationsIntegrationIdCreateContactRouteImport
      parentRoute: typeof AuthenticatedAliasRoute
    }
    '/_authenticated/$alias/integrations/$integrationId/callback': {
      id: '/_authenticated/$alias/integrations/$integrationId/callback'
      path: '/integrations/$integrationId/callback'
      fullPath: '/$alias/integrations/$integrationId/callback'
      preLoaderRoute: typeof AuthenticatedAliasIntegrationsIntegrationIdCallbackRouteImport
      parentRoute: typeof AuthenticatedAliasRoute
    }
    '/_authenticated/$alias/integrations/$integrationId/activate': {
      id: '/_authenticated/$alias/integrations/$integrationId/activate'
      path: '/integrations/$integrationId/activate'
      fullPath: '/$alias/integrations/$integrationId/activate'
      preLoaderRoute: typeof AuthenticatedAliasIntegrationsIntegrationIdActivateRouteImport
      parentRoute: typeof AuthenticatedAliasRoute
    }
    '/_authenticated/$alias/_app/scorecard/$scorecardId': {
      id: '/_authenticated/$alias/_app/scorecard/$scorecardId'
      path: '/scorecard/$scorecardId'
      fullPath: '/$alias/scorecard/$scorecardId'
      preLoaderRoute: typeof AuthenticatedAliasAppScorecardScorecardIdRouteImport
      parentRoute: typeof AuthenticatedAliasAppRoute
    }
    '/_authenticated/$alias/_app/members/$memberId': {
      id: '/_authenticated/$alias/_app/members/$memberId'
      path: '/members/$memberId'
      fullPath: '/$alias/members/$memberId'
      preLoaderRoute: typeof AuthenticatedAliasAppMembersMemberIdRouteImport
      parentRoute: typeof AuthenticatedAliasAppRoute
    }
    '/_authenticated/$alias/_app/interaction/lookup': {
      id: '/_authenticated/$alias/_app/interaction/lookup'
      path: '/interaction/lookup'
      fullPath: '/$alias/interaction/lookup'
      preLoaderRoute: typeof AuthenticatedAliasAppInteractionLookupRouteImport
      parentRoute: typeof AuthenticatedAliasAppRoute
    }
    '/_authenticated/$alias/_app/contact-logs/$contactLogId': {
      id: '/_authenticated/$alias/_app/contact-logs/$contactLogId'
      path: '/contact-logs/$contactLogId'
      fullPath: '/$alias/contact-logs/$contactLogId'
      preLoaderRoute: typeof AuthenticatedAliasAppContactLogsContactLogIdRouteImport
      parentRoute: typeof AuthenticatedAliasAppRoute
    }
    '/_authenticated/$alias/v2/scorecard/$scorecardId/': {
      id: '/_authenticated/$alias/v2/scorecard/$scorecardId/'
      path: '/'
      fullPath: '/$alias/v2/scorecard/$scorecardId/'
      preLoaderRoute: typeof AuthenticatedAliasV2ScorecardScorecardIdIndexRouteImport
      parentRoute: typeof AuthenticatedAliasV2ScorecardScorecardIdRoute
    }
    '/_authenticated/$alias/settings/scorecards/$scorecardId/': {
      id: '/_authenticated/$alias/settings/scorecards/$scorecardId/'
      path: '/'
      fullPath: '/$alias/settings/scorecards/$scorecardId/'
      preLoaderRoute: typeof AuthenticatedAliasSettingsScorecardsScorecardIdIndexRouteImport
      parentRoute: typeof AuthenticatedAliasSettingsScorecardsScorecardIdRoute
    }
    '/_authenticated/$alias/_app/scorecard/new/': {
      id: '/_authenticated/$alias/_app/scorecard/new/'
      path: '/scorecard/new'
      fullPath: '/$alias/scorecard/new/'
      preLoaderRoute: typeof AuthenticatedAliasAppScorecardNewIndexRouteImport
      parentRoute: typeof AuthenticatedAliasAppRoute
    }
    '/_authenticated/$alias/_app/scorecard/$scorecardId/': {
      id: '/_authenticated/$alias/_app/scorecard/$scorecardId/'
      path: '/'
      fullPath: '/$alias/scorecard/$scorecardId/'
      preLoaderRoute: typeof AuthenticatedAliasAppScorecardScorecardIdIndexRouteImport
      parentRoute: typeof AuthenticatedAliasAppScorecardScorecardIdRoute
    }
    '/_authenticated/$alias/_app/reports/pivot/': {
      id: '/_authenticated/$alias/_app/reports/pivot/'
      path: '/pivot'
      fullPath: '/$alias/reports/pivot/'
      preLoaderRoute: typeof AuthenticatedAliasAppReportsPivotIndexRouteImport
      parentRoute: typeof AuthenticatedAliasAppReportsRoute
    }
    '/_authenticated/$alias/_app/interaction/$contactLogId/': {
      id: '/_authenticated/$alias/_app/interaction/$contactLogId/'
      path: '/interaction/$contactLogId'
      fullPath: '/$alias/interaction/$contactLogId/'
      preLoaderRoute: typeof AuthenticatedAliasAppInteractionContactLogIdIndexRouteImport
      parentRoute: typeof AuthenticatedAliasAppRoute
    }
    '/_authenticated/$alias/_app/indicators/$indicatorId/': {
      id: '/_authenticated/$alias/_app/indicators/$indicatorId/'
      path: '/indicators/$indicatorId'
      fullPath: '/$alias/indicators/$indicatorId/'
      preLoaderRoute: typeof AuthenticatedAliasAppIndicatorsIndicatorIdIndexRouteImport
      parentRoute: typeof AuthenticatedAliasAppRoute
    }
    '/_authenticated/$alias/_app/scorecard/new/template': {
      id: '/_authenticated/$alias/_app/scorecard/new/template'
      path: '/scorecard/new/template'
      fullPath: '/$alias/scorecard/new/template'
      preLoaderRoute: typeof AuthenticatedAliasAppScorecardNewTemplateRouteImport
      parentRoute: typeof AuthenticatedAliasAppRoute
    }
    '/_authenticated/$alias/_app/scorecard/$scorecardId/edit': {
      id: '/_authenticated/$alias/_app/scorecard/$scorecardId/edit'
      path: '/edit'
      fullPath: '/$alias/scorecard/$scorecardId/edit'
      preLoaderRoute: typeof AuthenticatedAliasAppScorecardScorecardIdEditRouteImport
      parentRoute: typeof AuthenticatedAliasAppScorecardScorecardIdRoute
    }
    '/_authenticated/$alias/_app/highlights/$highlightCategoryId/new': {
      id: '/_authenticated/$alias/_app/highlights/$highlightCategoryId/new'
      path: '/$highlightCategoryId/new'
      fullPath: '/$alias/highlights/$highlightCategoryId/new'
      preLoaderRoute: typeof AuthenticatedAliasAppHighlightsHighlightCategoryIdNewRouteImport
      parentRoute: typeof AuthenticatedAliasAppHighlightsRoute
    }
    '/_authenticated/$alias/settings/scorecards/$scorecardId/settings/': {
      id: '/_authenticated/$alias/settings/scorecards/$scorecardId/settings/'
      path: '/settings'
      fullPath: '/$alias/settings/scorecards/$scorecardId/settings/'
      preLoaderRoute: typeof AuthenticatedAliasSettingsScorecardsScorecardIdSettingsIndexRouteImport
      parentRoute: typeof AuthenticatedAliasSettingsScorecardsScorecardIdRoute
    }
    '/_authenticated/$alias/settings/scorecards/$scorecardId/criteria/': {
      id: '/_authenticated/$alias/settings/scorecards/$scorecardId/criteria/'
      path: '/criteria'
      fullPath: '/$alias/settings/scorecards/$scorecardId/criteria/'
      preLoaderRoute: typeof AuthenticatedAliasSettingsScorecardsScorecardIdCriteriaIndexRouteImport
      parentRoute: typeof AuthenticatedAliasSettingsScorecardsScorecardIdRoute
    }
    '/_authenticated/$alias/v2/scorecard/$scorecardId/criteria/$criteriaId': {
      id: '/_authenticated/$alias/v2/scorecard/$scorecardId/criteria/$criteriaId'
      path: '/criteria/$criteriaId'
      fullPath: '/$alias/v2/scorecard/$scorecardId/criteria/$criteriaId'
      preLoaderRoute: typeof AuthenticatedAliasV2ScorecardScorecardIdCriteriaCriteriaIdRouteImport
      parentRoute: typeof AuthenticatedAliasV2ScorecardScorecardIdRoute
    }
    '/_authenticated/$alias/settings/scorecards/$scorecardId/criteria/$itemId': {
      id: '/_authenticated/$alias/settings/scorecards/$scorecardId/criteria/$itemId'
      path: '/criteria/$itemId'
      fullPath: '/$alias/settings/scorecards/$scorecardId/criteria/$itemId'
      preLoaderRoute: typeof AuthenticatedAliasSettingsScorecardsScorecardIdCriteriaItemIdRouteImport
      parentRoute: typeof AuthenticatedAliasSettingsScorecardsScorecardIdRoute
    }
    '/_authenticated/$alias/_app/scorecard/$scorecardId/edit/index2': {
      id: '/_authenticated/$alias/_app/scorecard/$scorecardId/edit/index2'
      path: '/index2'
      fullPath: '/$alias/scorecard/$scorecardId/edit/index2'
      preLoaderRoute: typeof AuthenticatedAliasAppScorecardScorecardIdEditIndex2RouteImport
      parentRoute: typeof AuthenticatedAliasAppScorecardScorecardIdEditRoute
    }
    '/_authenticated/$alias/_app/scorecard/$scorecardId/edit/$criteriaId': {
      id: '/_authenticated/$alias/_app/scorecard/$scorecardId/edit/$criteriaId'
      path: '/$criteriaId'
      fullPath: '/$alias/scorecard/$scorecardId/edit/$criteriaId'
      preLoaderRoute: typeof AuthenticatedAliasAppScorecardScorecardIdEditCriteriaIdRouteImport
      parentRoute: typeof AuthenticatedAliasAppScorecardScorecardIdEditRoute
    }
    '/_authenticated/$alias/_app/interaction/$contactLogId/dispute/$evaluationId': {
      id: '/_authenticated/$alias/_app/interaction/$contactLogId/dispute/$evaluationId'
      path: '/interaction/$contactLogId/dispute/$evaluationId'
      fullPath: '/$alias/interaction/$contactLogId/dispute/$evaluationId'
      preLoaderRoute: typeof AuthenticatedAliasAppInteractionContactLogIdDisputeEvaluationIdRouteImport
      parentRoute: typeof AuthenticatedAliasAppRoute
    }
    '/_authenticated/$alias/_app/highlights/$highlightCategoryId/edit/$highlightId': {
      id: '/_authenticated/$alias/_app/highlights/$highlightCategoryId/edit/$highlightId'
      path: '/$highlightCategoryId/edit/$highlightId'
      fullPath: '/$alias/highlights/$highlightCategoryId/edit/$highlightId'
      preLoaderRoute: typeof AuthenticatedAliasAppHighlightsHighlightCategoryIdEditHighlightIdRouteImport
      parentRoute: typeof AuthenticatedAliasAppHighlightsRoute
    }
    '/_authenticated/$alias/settings/scorecards/$scorecardId/criteria/new/$sectionId': {
      id: '/_authenticated/$alias/settings/scorecards/$scorecardId/criteria/new/$sectionId'
      path: '/criteria/new/$sectionId'
      fullPath: '/$alias/settings/scorecards/$scorecardId/criteria/new/$sectionId'
      preLoaderRoute: typeof AuthenticatedAliasSettingsScorecardsScorecardIdCriteriaNewSectionIdRouteImport
      parentRoute: typeof AuthenticatedAliasSettingsScorecardsScorecardIdRoute
    }
  }
}

interface AuthenticatedAliasAppHighlightsRouteChildren {
  AuthenticatedAliasAppHighlightsIndexRoute: typeof AuthenticatedAliasAppHighlightsIndexRoute
  AuthenticatedAliasAppHighlightsHighlightCategoryIdNewRoute: typeof AuthenticatedAliasAppHighlightsHighlightCategoryIdNewRoute
  AuthenticatedAliasAppHighlightsHighlightCategoryIdEditHighlightIdRoute: typeof AuthenticatedAliasAppHighlightsHighlightCategoryIdEditHighlightIdRoute
}

const AuthenticatedAliasAppHighlightsRouteChildren: AuthenticatedAliasAppHighlightsRouteChildren =
  {
    AuthenticatedAliasAppHighlightsIndexRoute:
      AuthenticatedAliasAppHighlightsIndexRoute,
    AuthenticatedAliasAppHighlightsHighlightCategoryIdNewRoute:
      AuthenticatedAliasAppHighlightsHighlightCategoryIdNewRoute,
    AuthenticatedAliasAppHighlightsHighlightCategoryIdEditHighlightIdRoute:
      AuthenticatedAliasAppHighlightsHighlightCategoryIdEditHighlightIdRoute,
  }

const AuthenticatedAliasAppHighlightsRouteWithChildren =
  AuthenticatedAliasAppHighlightsRoute._addFileChildren(
    AuthenticatedAliasAppHighlightsRouteChildren,
  )

interface AuthenticatedAliasAppReportsRouteChildren {
  AuthenticatedAliasAppReportsPivotIndexRoute: typeof AuthenticatedAliasAppReportsPivotIndexRoute
}

const AuthenticatedAliasAppReportsRouteChildren: AuthenticatedAliasAppReportsRouteChildren =
  {
    AuthenticatedAliasAppReportsPivotIndexRoute:
      AuthenticatedAliasAppReportsPivotIndexRoute,
  }

const AuthenticatedAliasAppReportsRouteWithChildren =
  AuthenticatedAliasAppReportsRoute._addFileChildren(
    AuthenticatedAliasAppReportsRouteChildren,
  )

interface AuthenticatedAliasAppScorecardScorecardIdEditRouteChildren {
  AuthenticatedAliasAppScorecardScorecardIdEditCriteriaIdRoute: typeof AuthenticatedAliasAppScorecardScorecardIdEditCriteriaIdRoute
  AuthenticatedAliasAppScorecardScorecardIdEditIndex2Route: typeof AuthenticatedAliasAppScorecardScorecardIdEditIndex2Route
}

const AuthenticatedAliasAppScorecardScorecardIdEditRouteChildren: AuthenticatedAliasAppScorecardScorecardIdEditRouteChildren =
  {
    AuthenticatedAliasAppScorecardScorecardIdEditCriteriaIdRoute:
      AuthenticatedAliasAppScorecardScorecardIdEditCriteriaIdRoute,
    AuthenticatedAliasAppScorecardScorecardIdEditIndex2Route:
      AuthenticatedAliasAppScorecardScorecardIdEditIndex2Route,
  }

const AuthenticatedAliasAppScorecardScorecardIdEditRouteWithChildren =
  AuthenticatedAliasAppScorecardScorecardIdEditRoute._addFileChildren(
    AuthenticatedAliasAppScorecardScorecardIdEditRouteChildren,
  )

interface AuthenticatedAliasAppScorecardScorecardIdRouteChildren {
  AuthenticatedAliasAppScorecardScorecardIdEditRoute: typeof AuthenticatedAliasAppScorecardScorecardIdEditRouteWithChildren
  AuthenticatedAliasAppScorecardScorecardIdIndexRoute: typeof AuthenticatedAliasAppScorecardScorecardIdIndexRoute
}

const AuthenticatedAliasAppScorecardScorecardIdRouteChildren: AuthenticatedAliasAppScorecardScorecardIdRouteChildren =
  {
    AuthenticatedAliasAppScorecardScorecardIdEditRoute:
      AuthenticatedAliasAppScorecardScorecardIdEditRouteWithChildren,
    AuthenticatedAliasAppScorecardScorecardIdIndexRoute:
      AuthenticatedAliasAppScorecardScorecardIdIndexRoute,
  }

const AuthenticatedAliasAppScorecardScorecardIdRouteWithChildren =
  AuthenticatedAliasAppScorecardScorecardIdRoute._addFileChildren(
    AuthenticatedAliasAppScorecardScorecardIdRouteChildren,
  )

interface AuthenticatedAliasAppRouteChildren {
  AuthenticatedAliasAppHighlightsRoute: typeof AuthenticatedAliasAppHighlightsRouteWithChildren
  AuthenticatedAliasAppReportsRoute: typeof AuthenticatedAliasAppReportsRouteWithChildren
  AuthenticatedAliasAppIndexRoute: typeof AuthenticatedAliasAppIndexRoute
  AuthenticatedAliasAppContactLogsContactLogIdRoute: typeof AuthenticatedAliasAppContactLogsContactLogIdRoute
  AuthenticatedAliasAppInteractionLookupRoute: typeof AuthenticatedAliasAppInteractionLookupRoute
  AuthenticatedAliasAppMembersMemberIdRoute: typeof AuthenticatedAliasAppMembersMemberIdRoute
  AuthenticatedAliasAppScorecardScorecardIdRoute: typeof AuthenticatedAliasAppScorecardScorecardIdRouteWithChildren
  AuthenticatedAliasAppExploreIndexRoute: typeof AuthenticatedAliasAppExploreIndexRoute
  AuthenticatedAliasAppIndicatorsIndexRoute: typeof AuthenticatedAliasAppIndicatorsIndexRoute
  AuthenticatedAliasAppLeaderboardIndexRoute: typeof AuthenticatedAliasAppLeaderboardIndexRoute
  AuthenticatedAliasAppMembersIndexRoute: typeof AuthenticatedAliasAppMembersIndexRoute
  AuthenticatedAliasAppScorecardsIndexRoute: typeof AuthenticatedAliasAppScorecardsIndexRoute
  AuthenticatedAliasAppSearchIndexRoute: typeof AuthenticatedAliasAppSearchIndexRoute
  AuthenticatedAliasAppScorecardNewTemplateRoute: typeof AuthenticatedAliasAppScorecardNewTemplateRoute
  AuthenticatedAliasAppIndicatorsIndicatorIdIndexRoute: typeof AuthenticatedAliasAppIndicatorsIndicatorIdIndexRoute
  AuthenticatedAliasAppInteractionContactLogIdIndexRoute: typeof AuthenticatedAliasAppInteractionContactLogIdIndexRoute
  AuthenticatedAliasAppScorecardNewIndexRoute: typeof AuthenticatedAliasAppScorecardNewIndexRoute
  AuthenticatedAliasAppInteractionContactLogIdDisputeEvaluationIdRoute: typeof AuthenticatedAliasAppInteractionContactLogIdDisputeEvaluationIdRoute
}

const AuthenticatedAliasAppRouteChildren: AuthenticatedAliasAppRouteChildren = {
  AuthenticatedAliasAppHighlightsRoute:
    AuthenticatedAliasAppHighlightsRouteWithChildren,
  AuthenticatedAliasAppReportsRoute:
    AuthenticatedAliasAppReportsRouteWithChildren,
  AuthenticatedAliasAppIndexRoute: AuthenticatedAliasAppIndexRoute,
  AuthenticatedAliasAppContactLogsContactLogIdRoute:
    AuthenticatedAliasAppContactLogsContactLogIdRoute,
  AuthenticatedAliasAppInteractionLookupRoute:
    AuthenticatedAliasAppInteractionLookupRoute,
  AuthenticatedAliasAppMembersMemberIdRoute:
    AuthenticatedAliasAppMembersMemberIdRoute,
  AuthenticatedAliasAppScorecardScorecardIdRoute:
    AuthenticatedAliasAppScorecardScorecardIdRouteWithChildren,
  AuthenticatedAliasAppExploreIndexRoute:
    AuthenticatedAliasAppExploreIndexRoute,
  AuthenticatedAliasAppIndicatorsIndexRoute:
    AuthenticatedAliasAppIndicatorsIndexRoute,
  AuthenticatedAliasAppLeaderboardIndexRoute:
    AuthenticatedAliasAppLeaderboardIndexRoute,
  AuthenticatedAliasAppMembersIndexRoute:
    AuthenticatedAliasAppMembersIndexRoute,
  AuthenticatedAliasAppScorecardsIndexRoute:
    AuthenticatedAliasAppScorecardsIndexRoute,
  AuthenticatedAliasAppSearchIndexRoute: AuthenticatedAliasAppSearchIndexRoute,
  AuthenticatedAliasAppScorecardNewTemplateRoute:
    AuthenticatedAliasAppScorecardNewTemplateRoute,
  AuthenticatedAliasAppIndicatorsIndicatorIdIndexRoute:
    AuthenticatedAliasAppIndicatorsIndicatorIdIndexRoute,
  AuthenticatedAliasAppInteractionContactLogIdIndexRoute:
    AuthenticatedAliasAppInteractionContactLogIdIndexRoute,
  AuthenticatedAliasAppScorecardNewIndexRoute:
    AuthenticatedAliasAppScorecardNewIndexRoute,
  AuthenticatedAliasAppInteractionContactLogIdDisputeEvaluationIdRoute:
    AuthenticatedAliasAppInteractionContactLogIdDisputeEvaluationIdRoute,
}

const AuthenticatedAliasAppRouteWithChildren =
  AuthenticatedAliasAppRoute._addFileChildren(
    AuthenticatedAliasAppRouteChildren,
  )

interface AuthenticatedAliasSettingsScorecardsScorecardIdRouteChildren {
  AuthenticatedAliasSettingsScorecardsScorecardIdIndexRoute: typeof AuthenticatedAliasSettingsScorecardsScorecardIdIndexRoute
  AuthenticatedAliasSettingsScorecardsScorecardIdCriteriaItemIdRoute: typeof AuthenticatedAliasSettingsScorecardsScorecardIdCriteriaItemIdRoute
  AuthenticatedAliasSettingsScorecardsScorecardIdCriteriaIndexRoute: typeof AuthenticatedAliasSettingsScorecardsScorecardIdCriteriaIndexRoute
  AuthenticatedAliasSettingsScorecardsScorecardIdSettingsIndexRoute: typeof AuthenticatedAliasSettingsScorecardsScorecardIdSettingsIndexRoute
  AuthenticatedAliasSettingsScorecardsScorecardIdCriteriaNewSectionIdRoute: typeof AuthenticatedAliasSettingsScorecardsScorecardIdCriteriaNewSectionIdRoute
}

const AuthenticatedAliasSettingsScorecardsScorecardIdRouteChildren: AuthenticatedAliasSettingsScorecardsScorecardIdRouteChildren =
  {
    AuthenticatedAliasSettingsScorecardsScorecardIdIndexRoute:
      AuthenticatedAliasSettingsScorecardsScorecardIdIndexRoute,
    AuthenticatedAliasSettingsScorecardsScorecardIdCriteriaItemIdRoute:
      AuthenticatedAliasSettingsScorecardsScorecardIdCriteriaItemIdRoute,
    AuthenticatedAliasSettingsScorecardsScorecardIdCriteriaIndexRoute:
      AuthenticatedAliasSettingsScorecardsScorecardIdCriteriaIndexRoute,
    AuthenticatedAliasSettingsScorecardsScorecardIdSettingsIndexRoute:
      AuthenticatedAliasSettingsScorecardsScorecardIdSettingsIndexRoute,
    AuthenticatedAliasSettingsScorecardsScorecardIdCriteriaNewSectionIdRoute:
      AuthenticatedAliasSettingsScorecardsScorecardIdCriteriaNewSectionIdRoute,
  }

const AuthenticatedAliasSettingsScorecardsScorecardIdRouteWithChildren =
  AuthenticatedAliasSettingsScorecardsScorecardIdRoute._addFileChildren(
    AuthenticatedAliasSettingsScorecardsScorecardIdRouteChildren,
  )

interface AuthenticatedAliasSettingsRouteChildren {
  AuthenticatedAliasSettingsGoalsRoute: typeof AuthenticatedAliasSettingsGoalsRoute
  AuthenticatedAliasSettingsIndexRoute: typeof AuthenticatedAliasSettingsIndexRoute
  AuthenticatedAliasSettingsAlertsAlertIdRoute: typeof AuthenticatedAliasSettingsAlertsAlertIdRoute
  AuthenticatedAliasSettingsApiTokensNewRoute: typeof AuthenticatedAliasSettingsApiTokensNewRoute
  AuthenticatedAliasSettingsChannelsChannelIdRoute: typeof AuthenticatedAliasSettingsChannelsChannelIdRoute
  AuthenticatedAliasSettingsGroupsGroupIdRoute: typeof AuthenticatedAliasSettingsGroupsGroupIdRoute
  AuthenticatedAliasSettingsMembersMemberIdRoute: typeof AuthenticatedAliasSettingsMembersMemberIdRoute
  AuthenticatedAliasSettingsMembersInvitesRoute: typeof AuthenticatedAliasSettingsMembersInvitesRoute
  AuthenticatedAliasSettingsRolesRoleIdRoute: typeof AuthenticatedAliasSettingsRolesRoleIdRoute
  AuthenticatedAliasSettingsScorecardsScorecardIdRoute: typeof AuthenticatedAliasSettingsScorecardsScorecardIdRouteWithChildren
  AuthenticatedAliasSettingsWorkspacesWorkspaceIdRoute: typeof AuthenticatedAliasSettingsWorkspacesWorkspaceIdRoute
  AuthenticatedAliasSettingsAlertsIndexRoute: typeof AuthenticatedAliasSettingsAlertsIndexRoute
  AuthenticatedAliasSettingsApiTokensIndexRoute: typeof AuthenticatedAliasSettingsApiTokensIndexRoute
  AuthenticatedAliasSettingsAutoQaPreferencesIndexRoute: typeof AuthenticatedAliasSettingsAutoQaPreferencesIndexRoute
  AuthenticatedAliasSettingsBillingIndexRoute: typeof AuthenticatedAliasSettingsBillingIndexRoute
  AuthenticatedAliasSettingsChannelsIndexRoute: typeof AuthenticatedAliasSettingsChannelsIndexRoute
  AuthenticatedAliasSettingsFlagsIndexRoute: typeof AuthenticatedAliasSettingsFlagsIndexRoute
  AuthenticatedAliasSettingsGroupsIndexRoute: typeof AuthenticatedAliasSettingsGroupsIndexRoute
  AuthenticatedAliasSettingsIntentsIndexRoute: typeof AuthenticatedAliasSettingsIntentsIndexRoute
  AuthenticatedAliasSettingsMembersIndexRoute: typeof AuthenticatedAliasSettingsMembersIndexRoute
  AuthenticatedAliasSettingsMetricsIndexRoute: typeof AuthenticatedAliasSettingsMetricsIndexRoute
  AuthenticatedAliasSettingsOrganizationIndexRoute: typeof AuthenticatedAliasSettingsOrganizationIndexRoute
  AuthenticatedAliasSettingsProfileIndexRoute: typeof AuthenticatedAliasSettingsProfileIndexRoute
  AuthenticatedAliasSettingsRolesIndexRoute: typeof AuthenticatedAliasSettingsRolesIndexRoute
  AuthenticatedAliasSettingsScorecardsIndexRoute: typeof AuthenticatedAliasSettingsScorecardsIndexRoute
  AuthenticatedAliasSettingsTopicsIndexRoute: typeof AuthenticatedAliasSettingsTopicsIndexRoute
  AuthenticatedAliasSettingsTranscriptionIndexRoute: typeof AuthenticatedAliasSettingsTranscriptionIndexRoute
  AuthenticatedAliasSettingsWorkspacesIndexRoute: typeof AuthenticatedAliasSettingsWorkspacesIndexRoute
}

const AuthenticatedAliasSettingsRouteChildren: AuthenticatedAliasSettingsRouteChildren =
  {
    AuthenticatedAliasSettingsGoalsRoute: AuthenticatedAliasSettingsGoalsRoute,
    AuthenticatedAliasSettingsIndexRoute: AuthenticatedAliasSettingsIndexRoute,
    AuthenticatedAliasSettingsAlertsAlertIdRoute:
      AuthenticatedAliasSettingsAlertsAlertIdRoute,
    AuthenticatedAliasSettingsApiTokensNewRoute:
      AuthenticatedAliasSettingsApiTokensNewRoute,
    AuthenticatedAliasSettingsChannelsChannelIdRoute:
      AuthenticatedAliasSettingsChannelsChannelIdRoute,
    AuthenticatedAliasSettingsGroupsGroupIdRoute:
      AuthenticatedAliasSettingsGroupsGroupIdRoute,
    AuthenticatedAliasSettingsMembersMemberIdRoute:
      AuthenticatedAliasSettingsMembersMemberIdRoute,
    AuthenticatedAliasSettingsMembersInvitesRoute:
      AuthenticatedAliasSettingsMembersInvitesRoute,
    AuthenticatedAliasSettingsRolesRoleIdRoute:
      AuthenticatedAliasSettingsRolesRoleIdRoute,
    AuthenticatedAliasSettingsScorecardsScorecardIdRoute:
      AuthenticatedAliasSettingsScorecardsScorecardIdRouteWithChildren,
    AuthenticatedAliasSettingsWorkspacesWorkspaceIdRoute:
      AuthenticatedAliasSettingsWorkspacesWorkspaceIdRoute,
    AuthenticatedAliasSettingsAlertsIndexRoute:
      AuthenticatedAliasSettingsAlertsIndexRoute,
    AuthenticatedAliasSettingsApiTokensIndexRoute:
      AuthenticatedAliasSettingsApiTokensIndexRoute,
    AuthenticatedAliasSettingsAutoQaPreferencesIndexRoute:
      AuthenticatedAliasSettingsAutoQaPreferencesIndexRoute,
    AuthenticatedAliasSettingsBillingIndexRoute:
      AuthenticatedAliasSettingsBillingIndexRoute,
    AuthenticatedAliasSettingsChannelsIndexRoute:
      AuthenticatedAliasSettingsChannelsIndexRoute,
    AuthenticatedAliasSettingsFlagsIndexRoute:
      AuthenticatedAliasSettingsFlagsIndexRoute,
    AuthenticatedAliasSettingsGroupsIndexRoute:
      AuthenticatedAliasSettingsGroupsIndexRoute,
    AuthenticatedAliasSettingsIntentsIndexRoute:
      AuthenticatedAliasSettingsIntentsIndexRoute,
    AuthenticatedAliasSettingsMembersIndexRoute:
      AuthenticatedAliasSettingsMembersIndexRoute,
    AuthenticatedAliasSettingsMetricsIndexRoute:
      AuthenticatedAliasSettingsMetricsIndexRoute,
    AuthenticatedAliasSettingsOrganizationIndexRoute:
      AuthenticatedAliasSettingsOrganizationIndexRoute,
    AuthenticatedAliasSettingsProfileIndexRoute:
      AuthenticatedAliasSettingsProfileIndexRoute,
    AuthenticatedAliasSettingsRolesIndexRoute:
      AuthenticatedAliasSettingsRolesIndexRoute,
    AuthenticatedAliasSettingsScorecardsIndexRoute:
      AuthenticatedAliasSettingsScorecardsIndexRoute,
    AuthenticatedAliasSettingsTopicsIndexRoute:
      AuthenticatedAliasSettingsTopicsIndexRoute,
    AuthenticatedAliasSettingsTranscriptionIndexRoute:
      AuthenticatedAliasSettingsTranscriptionIndexRoute,
    AuthenticatedAliasSettingsWorkspacesIndexRoute:
      AuthenticatedAliasSettingsWorkspacesIndexRoute,
  }

const AuthenticatedAliasSettingsRouteWithChildren =
  AuthenticatedAliasSettingsRoute._addFileChildren(
    AuthenticatedAliasSettingsRouteChildren,
  )

interface AuthenticatedAliasV2ScorecardScorecardIdRouteChildren {
  AuthenticatedAliasV2ScorecardScorecardIdIndexRoute: typeof AuthenticatedAliasV2ScorecardScorecardIdIndexRoute
  AuthenticatedAliasV2ScorecardScorecardIdCriteriaCriteriaIdRoute: typeof AuthenticatedAliasV2ScorecardScorecardIdCriteriaCriteriaIdRoute
}

const AuthenticatedAliasV2ScorecardScorecardIdRouteChildren: AuthenticatedAliasV2ScorecardScorecardIdRouteChildren =
  {
    AuthenticatedAliasV2ScorecardScorecardIdIndexRoute:
      AuthenticatedAliasV2ScorecardScorecardIdIndexRoute,
    AuthenticatedAliasV2ScorecardScorecardIdCriteriaCriteriaIdRoute:
      AuthenticatedAliasV2ScorecardScorecardIdCriteriaCriteriaIdRoute,
  }

const AuthenticatedAliasV2ScorecardScorecardIdRouteWithChildren =
  AuthenticatedAliasV2ScorecardScorecardIdRoute._addFileChildren(
    AuthenticatedAliasV2ScorecardScorecardIdRouteChildren,
  )

interface AuthenticatedAliasV2RouteChildren {
  AuthenticatedAliasV2GenerateRoute: typeof AuthenticatedAliasV2GenerateRoute
  AuthenticatedAliasV2ScorecardScorecardIdRoute: typeof AuthenticatedAliasV2ScorecardScorecardIdRouteWithChildren
}

const AuthenticatedAliasV2RouteChildren: AuthenticatedAliasV2RouteChildren = {
  AuthenticatedAliasV2GenerateRoute: AuthenticatedAliasV2GenerateRoute,
  AuthenticatedAliasV2ScorecardScorecardIdRoute:
    AuthenticatedAliasV2ScorecardScorecardIdRouteWithChildren,
}

const AuthenticatedAliasV2RouteWithChildren =
  AuthenticatedAliasV2Route._addFileChildren(AuthenticatedAliasV2RouteChildren)

interface AuthenticatedAliasRouteChildren {
  AuthenticatedAliasAppRoute: typeof AuthenticatedAliasAppRouteWithChildren
  AuthenticatedAliasSettingsRoute: typeof AuthenticatedAliasSettingsRouteWithChildren
  AuthenticatedAliasV2Route: typeof AuthenticatedAliasV2RouteWithChildren
  AuthenticatedAliasSetupCustomizeRoute: typeof AuthenticatedAliasSetupCustomizeRoute
  AuthenticatedAliasSetupUploadRoute: typeof AuthenticatedAliasSetupUploadRoute
  AuthenticatedAliasIntegrationsIntegrationIdActivateRoute: typeof AuthenticatedAliasIntegrationsIntegrationIdActivateRoute
  AuthenticatedAliasIntegrationsIntegrationIdCallbackRoute: typeof AuthenticatedAliasIntegrationsIntegrationIdCallbackRoute
  AuthenticatedAliasIntegrationsIntegrationIdCreateContactRoute: typeof AuthenticatedAliasIntegrationsIntegrationIdCreateContactRoute
  AuthenticatedAliasPrintEvaluationsEvaluationIdRoute: typeof AuthenticatedAliasPrintEvaluationsEvaluationIdRoute
}

const AuthenticatedAliasRouteChildren: AuthenticatedAliasRouteChildren = {
  AuthenticatedAliasAppRoute: AuthenticatedAliasAppRouteWithChildren,
  AuthenticatedAliasSettingsRoute: AuthenticatedAliasSettingsRouteWithChildren,
  AuthenticatedAliasV2Route: AuthenticatedAliasV2RouteWithChildren,
  AuthenticatedAliasSetupCustomizeRoute: AuthenticatedAliasSetupCustomizeRoute,
  AuthenticatedAliasSetupUploadRoute: AuthenticatedAliasSetupUploadRoute,
  AuthenticatedAliasIntegrationsIntegrationIdActivateRoute:
    AuthenticatedAliasIntegrationsIntegrationIdActivateRoute,
  AuthenticatedAliasIntegrationsIntegrationIdCallbackRoute:
    AuthenticatedAliasIntegrationsIntegrationIdCallbackRoute,
  AuthenticatedAliasIntegrationsIntegrationIdCreateContactRoute:
    AuthenticatedAliasIntegrationsIntegrationIdCreateContactRoute,
  AuthenticatedAliasPrintEvaluationsEvaluationIdRoute:
    AuthenticatedAliasPrintEvaluationsEvaluationIdRoute,
}

const AuthenticatedAliasRouteWithChildren =
  AuthenticatedAliasRoute._addFileChildren(AuthenticatedAliasRouteChildren)

interface AuthenticatedRouteChildren {
  AuthenticatedAliasRoute: typeof AuthenticatedAliasRouteWithChildren
  AuthenticatedIndexRoute: typeof AuthenticatedIndexRoute
  AuthenticatedOauthAuthorizeRoute: typeof AuthenticatedOauthAuthorizeRoute
  AuthenticatedWelcomeOrganizationDetailsRoute: typeof AuthenticatedWelcomeOrganizationDetailsRoute
  AuthenticatedOrgOrgIdSplatRoute: typeof AuthenticatedOrgOrgIdSplatRoute
  AuthenticatedORGSplatRoute: typeof AuthenticatedORGSplatRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedAliasRoute: AuthenticatedAliasRouteWithChildren,
  AuthenticatedIndexRoute: AuthenticatedIndexRoute,
  AuthenticatedOauthAuthorizeRoute: AuthenticatedOauthAuthorizeRoute,
  AuthenticatedWelcomeOrganizationDetailsRoute:
    AuthenticatedWelcomeOrganizationDetailsRoute,
  AuthenticatedOrgOrgIdSplatRoute: AuthenticatedOrgOrgIdSplatRoute,
  AuthenticatedORGSplatRoute: AuthenticatedORGSplatRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  PublicLoginRoute: PublicLoginRoute,
  PublicLogoutRoute: PublicLogoutRoute,
  PublicAuthCallbackRoute: PublicAuthCallbackRoute,
  PublicAuthCodeRoute: PublicAuthCodeRoute,
  PublicSignupCodeRoute: PublicSignupCodeRoute,
  PublicSignupOrganizationRoute: PublicSignupOrganizationRoute,
  PublicRegisterIndexRoute: PublicRegisterIndexRoute,
  PublicSignupIndexRoute: PublicSignupIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
